import _ from "lodash";
import React, { createRef } from "react";
import classes from "./CreateDropDown.scss";
import {
  AddCircleIcon,
  GoogleDriveIcon,
  ToddleIcon,
  ResourcesLineIcon,
  ImageIcon,
  LinkIconV2,
  GoogleDriveIconV2,
  OneDriveIcon,
  NoteIcon,
} from "SvgComponents";
import {
  WorkbookOutlined,
  LinkOutlined,
  DeviceDesktopOutlined,
  WorkbookColored,
  GoogleDriveColored,
  OneDriveColored,
  NoteOutlined,
  PortfolioOutlined,
  CameraOutlined,
  VideoOutlined,
  MicrophoneOutlined,
  ImageSquareOutlined,
  UploadOutlined,
  SharePointColored,
  SearchOutlined,
  UploadCloudOutlined,
  MoveToAssignedCircleOutlined,
  PageSquareColored,
  SlidesColored,
  SheetsColored,
  GoogleColored,
  MicrosoftColored,
  ScopeAndSequenceAddOutlined,
  PageFoldPortraitOutlined,
  GooglePhotosBrand,
} from "@toddle-edu/ds-icons";
import { CreatePost } from "Post";
import {
  colors,
  ICONS,
  MICROSOFT_TEMPLATE_SUPPORTED_MIMETYPE,
} from "Constants";
import DropzoneComponent from "UIComponents/DropzoneComponent";
import KeyboardShortcuts from "UIComponents/KeyboardShortcuts";
import LinkModal from "UIComponents/LinkModal";
import GooglePicker from "UIComponents/GooglePicker";
import MicrosoftPicker from "UIComponents/MicrosoftPicker";
import SharepointPicker from "UIComponents/SharepointPicker";
import SharepointPickerV2 from "UIComponents/SharepointPicker/SharepointPickerV2";
import CreateDriveDocument from "UIComponents/CreateDriveDocument";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import I18nHOC from "UIComponents/I18nHOC";
import AddNoteDialogue from "UIComponents/AddNoteDialogue";
import UIModal from "UIComponents/UIModal";
import { AudioRecorderV5 } from "UIComponents/AudioRecorderV5/AudioRecorderV5";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { compose, graphql } from "lib/apolloClient";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import ACLStore from "lib/aclStore";
import classNames from "classnames";
import {
  canEditPdfInPdftron,
  shouldConverPdfToWorkbook,
  getAttachmentSendObj,
  getFileExtensionFromMimeType,
  shouldEnableWorkbookSchoolTemplateLibrary,
  onEnterOrSpaceKeyDown,
  generateRandomId,
  WORKBOOK_MODE_TYPES,
  isTabletByUserAgent,
} from "Utils";
import {
  isIncreasedUploadLimitEnabled,
  SUBMISSION_MAX_AUDIO_RECORD_LIMIT,
} from "Post/utils";
import {
  enableSharepointPickerForUser,
  enableSharepointPickerV2ForUser,
} from "UIComponents/SharepointPicker/modules/Utils";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import WorkbookTemplateWrapper from "AppComponents/WorkbookTemplate";
import WorkbookTemplateWrapperV2 from "AppComponents/WorkbookTemplate/WorkbookTemplateWrapperV2";
import CaptureImage from "Post/routes/CreatePost/components/Screens/CaptureImage";
import CaptureVideo from "Post/routes/CreatePost/components/Screens/CaptureVideo";
import VoiceRecorder from "Post/routes/CreatePost/components/Screens/VoiceRecorder";
import VoiceRecorderV2 from "Post/routes/CreatePost/components/Screens/VoiceRecorderV2";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import ResourceBank from "AppComponents/ResourceBank";
import LTIClassroomWrapper from "AppComponents/LTIClassroomWrapper";
import { getLTIIntegrationsCredsQuery } from "SchoolSetup/routes/LTISettings/modules/LTISettingsQueries.js";

import {
  getGradeBasicDetailsFromCache,
  getOrganizationGlobalConstantsFromCache,
} from "modules/CommonGraphqlHelpers";
import {
  ENABLE_GOOGLE_DRIVE,
  ENABLE_ONE_DRIVE,
  ENABLE_STUDENT_FILES_FOLDER_UPLOAD,
  ENABLE_STUDENT_DRIVE_FOLDER_UPLOAD,
  ENABLE_EDUCATOR_CENTRE_FOLDER_UPLOAD,
  ENABLE_CREATE_DRIVE_DOCUMENTS,
} from "Constants/permissionConstants";
import {
  Badge,
  Button,
  Dropdown,
  DropdownMenu,
  IconButton,
  Tooltip,
  SplitButtonDropdown,
  ButtonDisclosure,
  Modal,
} from "@toddle-edu/ds-web";
import { uploadAttachments } from "Post/modules/PostModule";
import { updateAttachment } from "OrganizationResources/modules/OrganizationResourcesModule";
import { getOrganizationGlobalConstantsQuery } from "modules/CommonQuery";
import {
  GOOGLE_SERVICE_TYPE,
  MICROSOFT_SERVICE_TYPE,
  STUDENT_TEMPLATE_OPTION_NONE,
  SHIFT_ENTER_SUBMIT_SHORTCUT,
} from "Constants/stringConstants";
import { onEnterOrSpaceKeyDownWithCodeMapping } from "Utils/AccessibilityHelpers";
import ToddleDoc from "AppComponents/ToddleDoc";
import CodeEditor from "AppComponents/AIComponents/AITutorCodeEditorModality";
import GooglePhotosPicker from "UIComponents/GooglePhotosPicker";
import { enableGooglePhotosPicker } from "UIComponents/GooglePhotosPicker/modules/utils";

const DROP_DOWN_OPTIONS = [
  { key: "upload_device", label: "upload_device" },
  { key: "add_link", label: "add_link" },
  { key: "add_google_drive", label: "add_google_drive" },
  { key: "add_one_drive", label: "add_one_drive" },
];

const styles = {
  iconButtonStyle: {
    color: "var(--decorative-foreground-subtle-violet)",
  },
  overlayInnerStyle: {
    maxWidth: "280px",
  },
};

const DROP_DOWN_OPTIONS_WITH_ICONS = [
  { key: "add_link", label: "add_link", icon: <LinkOutlined /> },
  {
    key: "add_google_drive",
    label: "google_drive",
    icon: <GoogleDriveColored />,
  },
  {
    key: "add_one_drive",
    label: "one_drive",
    icon: <OneDriveColored />,
  },
  {
    key: "upload_device",
    label: "upload_device",
    icon: <DeviceDesktopOutlined />,
  },
];
const GOOGLE_OPTIONS = [
  {
    key: "NEW_GOOGLE_DOCUMENT",
    label: "google_doc",
    mimeType: "application/vnd.google-apps.document",
    icon: <PageSquareColored />,
  },
  {
    key: "NEW_GOOGLE_SPREADSHEET",
    label: "google_sheet",
    mimeType: "application/vnd.google-apps.spreadsheet",
    icon: <SheetsColored />,
  },
  {
    key: "NEW_GOOGLE_PRESENTATION",
    label: "google_slide",
    mimeType: "application/vnd.google-apps.presentation",
    icon: <SlidesColored />,
  },
];

const MICROSOFT_OPTIONS = [
  {
    key: "NEW_MICROSOFT_DOCUMENT",
    label: "microsoft_word",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    icon: <PageSquareColored />,
  },
  {
    key: "NEW_MICROSOFT_SPREADSHEET",
    label: "microsoft_excel",
    mimeType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: <SheetsColored />,
  },
  {
    key: "NEW_MICROSOFT_PRESENTATION",
    label: "microsoft_powerpoint",
    mimeType:
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    icon: <SlidesColored />,
  },
];

const CREATE = "create";
const EDIT = "edit";
const LINK = "add_link";
const UPLOAD_FROM_DEVICE = "upload_device";
const NOTE = "add_note";
const RESOURCE = "select_resource";
const WORKBOOK = "create_template_multipage";
const ONE_DRIVE = "add_one_drive";
const GOOGLE_DRIVE = "add_google_drive";
const GOOGLE_PHOTOS_PICKER = "add_google_photos";
const SHAREPOINT_DRIVE = "add_sharepoint_drive";

const CAPTURE_IMAGE = "capture_image";
const CAPTURE_VIDEO = "capture_video";
const CAPTURE_VOICE = "capture_voice";
const UPLOAD_FOLDER = "upload_folder";
const SEARCH_ON_PIXABAY = "search_on_pixabay";

const CAPTURE_MEDIA = "capture_media";
const UPLOAD_IMAGE = "upload_image";
const MICROSOFT_DRIVE_OPTION = {
  key: ONE_DRIVE,
  label: "add_one_drive",
  perm: ENABLE_ONE_DRIVE,
  accept: MICROSOFT_TEMPLATE_SUPPORTED_MIMETYPE,
  icon: <OneDriveColored size={"xx-small"} />,
};
const SHAREPOINT_DRIVE_OPTION = {
  key: SHAREPOINT_DRIVE,
  label: "add_sharepoint_drive",
  accept: MICROSOFT_TEMPLATE_SUPPORTED_MIMETYPE,
  icon: <SharePointColored size={"xx-small"} />,
};

const CODE_MAPPING = {
  Digit1: 1,
  Digit2: 2,
  Digit3: 3,
  Digit4: 4,
  Digit5: 5,
  Digit6: 6,
};
const getIconButtonOptions = ({
  testId,
  iconButtonSize,
  iconButtonVariant,
  iconButtonType,
  iconButtonVariantV2,
  disableAllOptions,
  showPlaceholderFileIcon,
  isAudioDisabled,
  isSharePointV2Enabled,
  iconButtonStyles = {},
  dsVersion,
}) => [
  {
    key: UPLOAD_FROM_DEVICE,
    label: "common:upload_device",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={
          showPlaceholderFileIcon ? (
            <UploadOutlined
              size={"x-small"}
              variant={_.isEqual(iconButtonVariant, "plain") ? "" : "subtle"}
            />
          ) : (
            <DeviceDesktopOutlined
              size={"x-small"}
              variant={_.isEqual(iconButtonVariant, "plain") ? "" : "subtle"}
            />
          )
        }
        testId={`${testId}-${UPLOAD_FROM_DEVICE}`}
        size={iconButtonSize}
        disabled={disableAllOptions}
      />
    ),
  },
  {
    key: LINK,
    label: "common:add_link",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={
          <LinkOutlined
            size={"x-small"}
            variant={_.isEqual(iconButtonVariant, "plain") ? "" : "subtle"}
          />
        }
        testId={`${testId}-${LINK}`}
        size={iconButtonSize}
        disabled={disableAllOptions}
        style={iconButtonStyles}
      />
    ),
  },
  {
    key: NOTE,
    label: "common:add_note",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<NoteOutlined size={"x-small"} variant={"subtle"} />}
        testId={`${testId}-${NOTE}`}
        size={iconButtonSize}
      />
    ),
  },
  {
    key: RESOURCE,
    label: "common:select_unit_resources",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<PortfolioOutlined size={"x-small"} variant={"subtle"} />}
        testId={`${testId}-${RESOURCE}`}
        size={iconButtonSize}
      />
    ),
  },
  {
    key: WORKBOOK,
    label: "create_template_multipage",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<WorkbookColored size={"x-small"} />}
        testId={`${testId}-${WORKBOOK}`}
        size={iconButtonSize}
      />
    ),
  },
  {
    key: GOOGLE_DRIVE,
    label: "common:add_google_drive",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<GoogleDriveColored size={"x-small"} />}
        testId={`${testId}-${GOOGLE_DRIVE}`}
        size={iconButtonSize}
        className={disableAllOptions ? classes.disableIcon : ""}
        disabled={disableAllOptions}
      />
    ),
  },
  {
    key: GOOGLE_PHOTOS_PICKER,
    label: "common:google_photos",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<GooglePhotosBrand size={"x-small"} />}
        testId={`${testId}-${GOOGLE_PHOTOS_PICKER}`}
        size={iconButtonSize}
        disabled={disableAllOptions}
      />
    ),
  },
  {
    key: ONE_DRIVE,
    label: "common:add_one_drive",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<OneDriveColored size={"x-small"} />}
        testId={`${testId}-${ONE_DRIVE}`}
        size={iconButtonSize}
        className={disableAllOptions ? classes.disableIcon : ""}
        disabled={disableAllOptions}
      />
    ),
  },
  {
    key: SHAREPOINT_DRIVE,
    label: isSharePointV2Enabled
      ? "common:add_onedrive_sharepoint"
      : "common:add_sharepoint_drive",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={
          isSharePointV2Enabled ? (
            <OneDriveColored size={"x-small"} />
          ) : (
            <SharePointColored size={"x-small"} />
          )
        }
        testId={`${testId}-${SHAREPOINT_DRIVE}`}
        size={iconButtonSize}
        className={disableAllOptions ? classes.disableIcon : ""}
        disabled={disableAllOptions}
      />
    ),
  },
  { key: "upload_from_unit_plan", label: "upload_from_unit_plan" },
  {
    key: CAPTURE_IMAGE,
    label: "common:capture_image",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<CameraOutlined size={"x-small"} />}
        size={iconButtonSize}
        disabled={disableAllOptions}
        testId={`${testId}-${CAPTURE_IMAGE}`}
      />
    ),
  },
  {
    key: CAPTURE_VIDEO,
    label: "common:capture_video",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<VideoOutlined size={"x-small"} />}
        size={iconButtonSize}
        disabled={disableAllOptions}
        testId={`${testId}-${CAPTURE_VIDEO}`}
      />
    ),
  },
  {
    key: CAPTURE_VOICE,
    label: "common:record_voice",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<MicrophoneOutlined size={"x-small"} />}
        size={iconButtonSize}
        disabled={disableAllOptions || isAudioDisabled}
        testId={`${testId}-${CAPTURE_VOICE}`}
      />
    ),
  },
  {
    key: CAPTURE_MEDIA,
    label: "journal:capture_media",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<CameraOutlined size={"x-small"} variant={"subtle"} />}
        size={iconButtonSize}
        testId={`${testId}-${CAPTURE_MEDIA}`}
      />
    ),
  },
  {
    key: UPLOAD_IMAGE,
    label: "common:upload_image",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<ImageSquareOutlined size={"x-small"} />}
        size={iconButtonSize}
        disabled={disableAllOptions}
        testId={`${testId}-${UPLOAD_IMAGE}`}
      />
    ),
  },
  {
    key: SEARCH_ON_PIXABAY,
    label: "common:search_on_pixabay",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<SearchOutlined size={"x-small"} />}
        size={iconButtonSize}
        testId={`${testId}-searchOnPixabay`}
        disabled={disableAllOptions}
      />
    ),
  },
  {
    key: "GOOGLE_DOCUMENTS",
    label: "common:create_from_google",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<GoogleColored size={"x-small"} />}
        size={iconButtonSize}
        testId={`${testId}-googleDocuments`}
        disabled={disableAllOptions}
      />
    ),
  },
  {
    key: "TODDLE_DOC",
    label: "classRoom:create_toddle_doc",
    icon: (
      <IconButton
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={
          <PageFoldPortraitOutlined
            style={styles.iconButtonStyle}
            size={"x-small"}
          />
        }
        size={iconButtonSize}
        testId={`${testId}-toddleDoc`}
        disabled={disableAllOptions}
      />
    ),
  },
  {
    key: "MICROSOFT_DOCUMENTS",
    label: "common:create_from_microsoft",
    icon: (
      <IconButton
        dsVersion={dsVersion}
        _legacy_variant={iconButtonVariant}
        type={iconButtonType}
        variant={iconButtonVariantV2}
        icon={<MicrosoftColored size={"x-small"} />}
        size={iconButtonSize}
        testId={`${testId}-microsoftDocuments`}
        disabled={disableAllOptions}
      />
    ),
  },
];

const getCaptureMediaOption = ({ t }) => [
  {
    key: "capture_image",
    label: t("journal:capture_photo"),
    icon: <CameraOutlined variant={"subtle"} />,
  },
  {
    key: "capture_video",
    label: t("journal:capture_video"),
    icon: <VideoOutlined variant={"subtle"} />,
  },
];

const getLocalizedOptions = ({ options, t }) => {
  return _.map(options, option => {
    return {
      ...option,
      label: t(option.label),
    };
  });
};

const buttonDropDownStyle = {
  containerStyle: {
    top: 0,
    width: "max-content",
    borderWidth: 0,
    left: 0,
    padding: 0,
    zIndex: 12,
  },
  buttonParentStyle: {
    width: "100%",
  },
};

const dropzoneStyle = {
  inset: "0",
  overflow: "hidden",
  alignItems: "flex-start",
};

const initialShowCaptureScreen = {
  capture_image: false,
  capture_video: false,
  capture_voice: false,
};

const captureOptions = ["capture_image", "capture_video", "capture_voice"];

const getSelectedCurriculumId = state => {
  return _.get(state, "platform.currentCurriculumProgram.id", undefined);
};

const extractAllKeysWithAccept = optionsList => {
  const keys = new Set();
  const acceptMap = new Map();

  const traverse = list => {
    _.forEach(list, option => {
      if (option?.key) {
        keys.add(option.key);
        if (option?.accept) {
          acceptMap.set(option.key, option.accept);
        }
      }
      if (option?.options) {
        traverse(option.options);
      }
    });
  };

  traverse(optionsList);

  return {
    keys,
    acceptMap,
  };
};

class CreateDropDown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showLinkModal: false,
      uploadCount: 0,
      showResourceBank: false,
      showMediaCreation: false,
      showNoteModal: false,
      showWorkbookModal: false,
      showCaptureScreen: initialShowCaptureScreen,
      showDescriptionModal: false,
      ltiModal: false,
      ltiService: null,
      createDriveModal: false,
      serviceType: null,
      documentType: null,
      showToddleDocModal: false,
      showNameModal: false,
      createdToddleDocAttachment: null,
      codeEditorAttachmentId: null,
      searchText: "",
    };

    if (props.customRef) {
      props.customRef(this);
    }
    if (props.createDropDownRef) {
      props.createDropDownRef(this);
    }
    this.customRef = null;
    this.dropzoneRef = createRef();
    this.googlePickerRef = createRef();
    this.microsoftPickerRef = createRef();
    this.sharepointPickerRef = createRef();
    this.realClickRef = createRef();
    this.dropdownComponentRef = createRef();

    this.realClickRef.current = true;
    this.innerDropzoneRef = createRef();
    this.innerFolderDropzoneRef = createRef();
    this.audioRecorderV5Ref = createRef();
    this.photosPickerRef = null;
  }

  isActive = () => {
    const {
      showNoteModal,
      showLinkModal,
      showResourceBank,
      showMediaCreation,
      ltiModal,
    } = this.state;

    return (
      ltiModal ||
      showNoteModal ||
      showLinkModal ||
      showMediaCreation ||
      showResourceBank
    );
  };

  toggleLTIComponent = () => {
    this.setState({ ltiModal: !this.state.ltiModal });
  };

  closeCreateDriveModal = () => {
    this.setState({ createDriveModal: false });
  };

  toggleMediaCreation = value => {
    this.setState({ showMediaCreation: value });
  };

  toggleLinkModal = () => {
    this.setState({ showLinkModal: !this.state.showLinkModal });
  };

  toddleAddNoteDialogue = () => {
    this.setState({ showNoteModal: !this.state.showNoteModal });
  };

  createToddleDoc = docName => {
    this.addNewToddleDoc(docName);
  };

  toddleAddToddleDocModal = () => {
    this.setState({
      showToddleDocModal: !this.state.showToddleDocModal,
    });
  };

  setGooglePhotosPickerRef = ref => {
    this.photosPickerRef = _.get(ref, "refs.wrappedInstance", {});
  };

  onGooglePhotosClicked = () => {
    if (this.photosPickerRef && this.photosPickerRef.launchGooglePhotosPicker) {
      this.photosPickerRef?.launchGooglePhotosPicker();
    }
  };

  closeToddleDoc = () => {
    this.setState({
      showToddleDocModal: false,
      createdToddleDocAttachment: null,
    });
  };

  onLinkAdd = async ({ attachments, id }) => {
    const {
      addAttachment,
      parentId,
      parentType,
      onMultipleFilesUploaded,
    } = this.props;
    const parentDetails = {
      parentId,
      parentType,
    };

    if (addAttachment) addAttachment(attachments, id, parentDetails);
    if (onMultipleFilesUploaded) await onMultipleFilesUploaded(attachments);

    if (this.state.uploadCount > 0) {
      this.updateFilesCount(-1);
    }
  };

  saveNote = async params => {
    const {
      addAttachment,
      parentId,
      parentType,
      onMultipleFilesUploaded,
    } = this.props;
    const parentDetails = {
      parentId,
      parentType,
    };

    const id = _.get(params, "id", "");
    if (addAttachment) {
      addAttachment(
        [
          {
            type: "NOTE",
            title: _.get(params, "note", ""),
          },
        ],
        id,
        parentDetails
      );
    }

    if (onMultipleFilesUploaded) {
      onMultipleFilesUploaded([
        {
          type: "NOTE",
          title: _.get(params, "note", ""),
        },
      ]);
    }
  };

  addNewToddleDoc = async params => {
    const { addAttachment, parentId, parentType } = this.props;
    const parentDetails = {
      parentId,
      parentType,
    };
    const id = generateRandomId();
    const attachmentsResponse = await addAttachment(
      [
        {
          type: "TODDLE_DOC",
          name: _.get(params, "name", ""),
        },
      ],
      id,
      parentDetails
    );
    this.setState({
      showToddleDocModal: true,
      createdToddleDocAttachment: attachmentsResponse,
    });
  };

  createNewCodeEditor = async () => {
    const { addAttachment } = this.props;
    const id = generateRandomId();

    const attachmentsResponse = await addAttachment(
      [
        {
          type: "CODE_EDITOR",
          name: "Untitled",
          modalityFile: {
            content: "",
            modalityType: "CODE_EDITOR",
          },
        },
      ],
      id
    );

    const attachmentId = _.get(
      attachmentsResponse,
      "[0].attachments.[0].id",
      null
    );

    if (attachmentId) {
      this.setState({ codeEditorAttachmentId: attachmentId });
    }
  };

  onTPSContentAdd = ({ attachment, id }) => {
    const { addAttachment, parentId, parentType } = this.props;
    const parentDetails = {
      parentId,
      parentType,
    };

    addAttachment(attachment, id, parentDetails);
  };

  onContentUploaded = async (
    params,
    uploadId,
    parentDetails,
    skipCopy = false
  ) => {
    const {
      addAttachment,
      inputTextFocusOnDrop,
      sourceType = "",
      curriculumProgramType = "",
      grade,
      userId,
    } = this.props;
    inputTextFocusOnDrop ? inputTextFocusOnDrop() : null;

    //override attachment type of pdf to workbook for Uploading UI
    if (
      sourceType === "STUDENT_TEMPLATE" &&
      shouldConverPdfToWorkbook({ curriculumProgramType, grade }) &&
      _.get(params, "type", "") === "FILE" &&
      _.get(params, "mimeType", "") === "application/pdf"
    ) {
      params.type = "WORKBOOK";
    }
    const isTemplateSourceType = _.includes(
      ["STUDENT_TEMPLATE", "PROJECT_GROUP_REPORT_TEMPLATE"],
      sourceType
    );
    const isLinkType = _.isEqual(_.get(params, "type", ""), "LINK");
    const metadata = _.get(params, "metadata", {});
    const serviceType = _.get(metadata, "serviceType", "");
    const isMicrosoft = _.isEqual(serviceType, "MICROSOFT");

    if (
      isTemplateSourceType &&
      isLinkType &&
      _.get(metadata, "permission", "") &&
      _.includes(["MICROSOFT", "GOOGLE"], serviceType)
    ) {
      if (skipCopy && ACLStore.can("FeatureFlag:UseNewDriveStructure")) {
        params.metadata = {
          ...metadata,
          skipCopy: true,
          ...(isMicrosoft ? { templateOwnerId: userId } : {}),
        };
      }
      if (
        !skipCopy &&
        isMicrosoft &&
        ACLStore.can("FeatureFlag:OneDriveTemplateSupport")
      ) {
        params.metadata = {
          ...metadata,
          copyToTemplatesFolder: true,
        };
      }
    }
    // When using the hidden-picker path (isNewDropdown / isSplitDropdown), the
    // DropzoneComponent has no uploadType prop. Merge the type captured when the
    // option was clicked so callers that destructure { uploadType } still work.
    const mergedParentDetails =
      this._pendingUploadType && !parentDetails?.uploadType
        ? { ...parentDetails, uploadType: this._pendingUploadType }
        : parentDetails;

    if (addAttachment) addAttachment([params], uploadId, mergedParentDetails);
  };

  updateFilesCount = count => {
    let newCount = this.state.uploadCount;
    newCount = newCount + count;

    if (this.props.updateLoadingState) {
      if (newCount > 0) {
        this.props.updateLoadingState(true);
      } else {
        this.props.updateLoadingState(false);
      }
    }
    this.setState({ uploadCount: newCount });
  };

  onFailedAllowedMimeType = () => {
    this.props.setToastMsg("toastMsgs:unsupported_extensions");
  };

  onSharePointClick = () => {
    if (
      this.sharepointPickerRef &&
      this.sharepointPickerRef.launchSharepointPicker
    ) {
      this.sharepointPickerRef.launchSharepointPicker();
    }
  };

  // This function will show popup if showDescription passed as true, on option click of create dropdownMenu.
  // Added only for upload_device, add_google_drive and add_one_drive
  // Eg : If we click on upload_device option, a popup will come before filePicker and onClick "Okay" of popup modal filePicker will be open.

  onFilePickerOptionClick = (e, callBack) => {
    const { showDescription } = this.props;
    if (showDescription) {
      if (this.realClickRef.current) {
        this.dropdownComponentRef.current = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          showDescriptionModal: true,
        });

        this.realClickRef.current = false;
      } else {
        this.realClickRef.current = true;
        if (callBack) {
          callBack();
        }
      }
    } else {
      if (callBack) {
        callBack();
      }
    }
  };

  onZoomMeetingClick = () => {
    if (this.zoomMeetingRef) {
      this.zoomMeetingRef.onLoginClick();
    }
  };

  onMicroSoftLoginCallBack = data => {};

  updateZoomMeetingRef = ref => {
    this.zoomMeetingRef = ref;
  };

  closeResourceBank = () => {
    this.setState({ showResourceBank: false });
  };

  toggleOpenWorkbook = showWorkbookModal => {
    this.setState({
      showWorkbookModal,
    });
  };

  onResourceBankContentUpload = params => {
    const { multiSelect, addAttachment } = this.props;
    addAttachment(multiSelect ? params : [params]);
  };

  onWorkbookSuccessfullyUpdate = attachment => {
    const { shouldCallMutation } = this.props;
    const attachmentId = _.get(attachment, "id", null);
    if (!attachment || !attachmentId) return;
    let omitKeys = [
      "parentType",
      "title",
      "streamUrl",
      "signedUrl",
      "isRead",
      "questionAttachment",
      "isAnnotationRead",
    ];
    if (shouldCallMutation) {
      omitKeys = [...omitKeys, ...["id"]];
    }
    const formattedAttachment = {
      ..._.omit(attachment, omitKeys),
    };

    this.onContentUploaded(formattedAttachment, attachmentId);
  };

  closeWorkBook = () => {
    this.toggleOpenWorkbook(false);
  };

  toggleCaptureScreen = params => {
    const { showCaptureScreen } = this.state;
    if (params && !_.get(params, "disabled", false)) {
      const { key } = params;
      const showCaptureScreenNew = { ...showCaptureScreen, [key]: true };
      this.setState({ showCaptureScreen: showCaptureScreenNew });
    } else {
      this.setState({ showCaptureScreen: initialShowCaptureScreen });
    }
  };

  updatePost = async ({ attachments, uploadId }) => {
    const {
      addAttachment,
      uploadAttachments,
      parentId,
      parentType,
    } = this.props;
    if (!_.isEmpty(attachments)) {
      this.toggleCaptureScreen();
      const uploadedAttachments = await uploadAttachments({
        attachments,
        parentType,
        parentId,
      });

      // removing file key in the object as its breaking the mutation
      const attachmentArray = _.map(uploadedAttachments, attachment => {
        return _.omit(attachment, [
          "file",
          "isRead",
          "questionAttachment",
          "signedUrl",
        ]);
      });
      if (addAttachment) addAttachment(attachmentArray, uploadId);
    }
  };

  createPreLaunchAttachment = (ltiServiceName, integrationData = {}) => {
    const { addAttachment, parentId, parentType, t } = this.props;

    const uploadId = generateRandomId();

    const { messageType = "", isPreLaunch = false } = integrationData;

    const placeholderAttachment = {
      type: "LINK",
      name: ltiServiceName,
      url: "",
      metadata: {
        type: "LTI_TOOL",
        service: ltiServiceName,
        isPreLaunch,
        messageType,
        attachmentContextId: null,
      },
    };

    const createdAttachments = addAttachment(
      [placeholderAttachment],
      uploadId,
      { parentId, parentType }
    );

    const attachmentId = _.get(createdAttachments, "[0].id");

    if (!attachmentId) {
      return { success: false };
    }

    return { attachmentId, success: true, isPreLaunch };
  };

  // Runs `action` immediately, or — when showDescription is true and this is the
  // first click — shows the confirmation modal first and defers `action` to "Okay".
  // Shared by upload_device, upload_image, Google Drive, OneDrive, and SharePoint.
  triggerPickerWithDescriptionGuard = action => {
    const { showDescription } = this.props;
    if (showDescription && this.realClickRef.current) {
      this.dropdownComponentRef.current = {
        click: () => {
          this.realClickRef.current = true;
          action();
        },
      };
      this.realClickRef.current = false;
      this.setState({ showDescriptionModal: true });
    } else {
      action();
    }
  };

  onClickDropdownOption = ({ key: rawKey }) => {
    // Strip the index suffix added by appendIndexWithKey (e.g. "upload_device-1" → "upload_device").
    // Note: option keys must not naturally end with "-{digits}" or they will be silently truncated here.
    const key = rawKey.replace(/-\d+$/, "");
    const {
      onDropDownOptionClick,
      showCaptureVoiceIcon,
      userType,
      onAfterDropdownOptionClick,
    } = this.props;
    const isCaptureOption = _.includes(
      showCaptureVoiceIcon
        ? _.filter(captureOptions, item => item !== "capture_voice")
        : captureOptions,
      key
    );
    if (key === "add_link") {
      this.setState({ showLinkModal: true });
    } else if (key === ONE_DRIVE) {
      this._pendingUploadType = null;
      this.triggerPickerWithDescriptionGuard(() =>
        this.microsoftPickerRef?.onAuthClick?.()
      );
    } else if (key === SHAREPOINT_DRIVE) {
      this._pendingUploadType = null;
      this.triggerPickerWithDescriptionGuard(() => this.onSharePointClick());
    } else if (key === "create_template_multipage") {
      this.setState({ showWorkbookModal: true });
    } else if (key === "add_note") {
      this.toddleAddNoteDialogue();
    } else if (key === "TODDLE_DOC") {
      this.toddleAddToddleDocModal();
    } else if (key === "CODE_EDITOR") {
      this.createNewCodeEditor();
    } else if (key === "upload_device" || key === UPLOAD_IMAGE) {
      // Store uploadType so onContentUploaded can forward it to addAttachment.
      // Required because the hidden DropzoneComponent is shared across all options.
      this._pendingUploadType = this._keyToType?.[rawKey];
      this.triggerPickerWithDescriptionGuard(
        this.props.onUploadFromDevice
          ? this.props.onUploadFromDevice
          : () => this.innerDropzoneRef?.current?.click()
      );
    } else if (key === "upload_folder") {
      // clicking the dropzone component programatically
      if (this.innerFolderDropzoneRef?.current?.click)
        this.innerFolderDropzoneRef.current.click();
    } else if (key === GOOGLE_DRIVE) {
      this._pendingUploadType = null;
      this.triggerPickerWithDescriptionGuard(() =>
        this.googlePickerRef?.onAuthClick?.()
      );
    } else if (key === GOOGLE_PHOTOS_PICKER) {
      this.onGooglePhotosClicked();
    } else if (isCaptureOption) {
      this.toggleCaptureScreen({ key });
    } else if (key === SEARCH_ON_PIXABAY) {
      this.setState({ showResourceBank: true });
    } else if (_.includes(key, "add_lti_resource")) {
      const dropdownLabel = _.last(_.split(key, "_"));
      const integrationCreds = this.props.ltiIntegrationCreds;

      if (_.isEmpty(integrationCreds)) {
        this.setState({ ltiService: dropdownLabel });
        this.toggleLTIComponent();
        return;
      }

      const matchingCred = _.find(integrationCreds, cred => {
        if (cred.serviceName === "CUSTOM") {
          return cred.name === dropdownLabel;
        } else {
          return cred.serviceName === dropdownLabel;
        }
      });

      if (!matchingCred) {
        this.setState({ ltiService: dropdownLabel });
        this.toggleLTIComponent();
        return;
      }

      const messageType = _.get(matchingCred, "metadata.messageType", "");
      const version = _.get(matchingCred, "version", "");
      const isPlagiarismCheck = _.get(
        matchingCred,
        "metadata.isPlagiarismCheck",
        false
      );

      const isPreLaunch =
        messageType === "BASIC_LTI_LAUNCH" &&
        version === "1.3" &&
        isPlagiarismCheck === true;

      const preLaunchName =
        matchingCred.serviceName === "CUSTOM"
          ? matchingCred.name
          : dropdownLabel;

      if (isPreLaunch) {
        this.createPreLaunchAttachment(preLaunchName, {
          messageType,
          version,
          isPreLaunch: true,
        });
      } else {
        this.setState({ ltiService: dropdownLabel });
        this.toggleLTIComponent();
      }
    } else if (
      _.includes(key, "NEW_GOOGLE") ||
      _.includes(key, "NEW_MICROSOFT")
    ) {
      const documentType = _.last(_.split(key, "_"));
      this.setState({
        serviceType: _.includes(key, "NEW_GOOGLE") ? "GOOGLE" : "MICROSOFT",
        documentType,
        createDriveModal: true,
      });
    } else {
      onDropDownOptionClick?.({ key });
    }

    onAfterDropdownOptionClick?.();
  };

  setInnerGooglePickerRef = ref => {
    this.googlePickerRef = ref;
  };

  setInnerMicrosoftPickerRef = ref => {
    this.microsoftPickerRef = ref;
  };

  setSharepointPickerRef = ref => {
    this.sharepointPickerRef = _.get(ref, "refs.wrappedInstance", {});
  };

  customizedFileObject = async (file, item) => {
    const sendObj = await getAttachmentSendObj(file, item);

    //override attachment type of pdf to workbook for Uploading UI
    const { sourceType = "", curriculumProgramType = "", grade } = this.props;
    if (
      sourceType === "STUDENT_TEMPLATE" &&
      shouldConverPdfToWorkbook({ curriculumProgramType, grade })
    ) {
      if (
        _.get(sendObj, "type", "") === "FILE" &&
        _.get(sendObj, "mimeType", "") === "application/pdf"
      ) {
        return {
          ...sendObj,
          type: "WORKBOOK",
          name: "Workbook",
        };
      }
    }

    return sendObj;
  };

  uploadAudioRecorderV5File = async audioFile => {
    const {
      addAttachment,
      uploadAttachments,
      parentId,
      parentType,
    } = this.props;
    if (!_.isEmpty(audioFile)) {
      const uploadedAttachments = await uploadAttachments({
        attachments: [audioFile],
        parentType,
        parentId,
      });

      // removing file key in the object as its breaking the mutation
      const attachmentArray = _.map(uploadedAttachments, attachment => {
        return _.omit(attachment, [
          "file",
          "isRead",
          "questionAttachment",
          "signedUrl",
        ]);
      });
      if (addAttachment) addAttachment(attachmentArray);
    }
  };

  setAudioRecorderV5ModalVisibility = visibility => {
    const { showCaptureScreen } = this.state;
    const newCaptureScreen = {
      ...showCaptureScreen,
      capture_voice: visibility,
    };
    this.setState({ showCaptureScreen: newCaptureScreen });
  };

  onAudioRecorderV5ModalClose = async () => {
    this.setAudioRecorderV5ModalVisibility(false);
  };

  restartAudioRecorderV5Recording = async () => {
    return new Promise(resolve => {
      this.setAudioRecorderV5ModalVisibility(false);
      resolve();
    }).then(() => {
      this.setAudioRecorderV5ModalVisibility(true);
    });
  };

  handleAudioRecorderV5File = props => {
    this.uploadAudioRecorderV5File(props);
    this.setAudioRecorderV5ModalVisibility(false);
  };

  handleSearchTextChange = text => {
    this.setState({ searchText: text });
  };

  getDropdownItemByKey = (
    {
      key,
      accept: acceptTypes,
      label,
      icon = null,
      type = null,
      isLabelLocalized = false,
      isDialogueBoxEnabled = false,
      dialogueBoxInfo = null,
      disabled,
      reloadText,
      submitText,
    },
    index
  ) => {
    const {
      isShowIconsInBar,
      t,
      parentId,
      parentType,
      accept,
      sourceType,
      isNewDropdown,
      curriculumProgramType,
      grade,
      showV2Icons,
      customDropZoneStyle,
      dropDownOptionButton,
      testId,
      maxSize,
      isSplitDropdown,
      iconButtonSize,
      disableAllOptions,
      showCaptureVoiceIcon,
      iconButtonVariant,
      iconButtonType,
      iconButtonVariantV2,
      reduceSpacingBetweenIcons,
      compactSpacingBetweenIcons,
      showPlaceholderFileIcon,
      isAudioDisabled,
      customOverlayStyle = {},
      audioRecordingLimit,
      dsVersion,
      showIconCardV2 = false,
      showCompactIcons = false,
      userType,
      iconButtonStyles,
    } = this.props;
    /**
     * Temporary condition to allow pdf files upload as student template files
     * Once we are in condition to open pdftron for all school, we will move this config in template only
     */
    if (
      sourceType === "STUDENT_TEMPLATE" &&
      (canEditPdfInPdftron({ curriculumProgramType, grade }) ||
        shouldConverPdfToWorkbook({ curriculumProgramType, grade }))
    ) {
      //push only if is not already present in acceptTypes or accept array
      if (!_.includes(acceptTypes, "application/pdf")) {
        acceptTypes?.push("application/pdf");
      }

      // overriding label as now it will accept pdf also and not just images.
      if (key === "upload_device") {
        label = "common:upload_device";

        const types = !_.isEmpty(acceptTypes) ? acceptTypes : accept;

        if (_.isArray(types) && isShowIconsInBar) {
          isLabelLocalized = true;
          const fileExtensions = _.map(types, type =>
            _.upperCase(getFileExtensionFromMimeType({ mimeType: type }))
          );

          label = (
            <React.Fragment>
              <div className={classes.textCenter}>
                {t("common:upload_device")}
              </div>
              <div>
                {t("common:accepted_file_formats", {
                  formats: _.join(fileExtensions, ", "),
                })}
              </div>
            </React.Fragment>
          );
        }
      }
    }

    const isCaptureOption = _.includes(
      showCaptureVoiceIcon
        ? _.filter(captureOptions, item => item !== "capture_voice")
        : captureOptions,
      key
    );
    const isSharePointV2Enabled = enableSharepointPickerV2ForUser(userType);
    const iconClasses = classNames({
      [classes.icon]: !isNewDropdown,
      [classes.iconButtonContainer]: showV2Icons,
      [classes.compactIcon]: showCompactIcons,
      [classes.iconButtonSpaceContainer]: reduceSpacingBetweenIcons,
      [classes.iconButtonMarginContainer]: compactSpacingBetweenIcons,
    });

    const hoverItemContainerClasses = classNames({
      [classes.hoverItemContainer]: !isNewDropdown,
      [classes.iconButtonContainer]: showV2Icons,
      [classes.splitDropdown]: !isNewDropdown && isSplitDropdown,
      [classes.iconButtonSpaceContainer]: reduceSpacingBetweenIcons,
      [classes.iconButtonMarginContainer]: compactSpacingBetweenIcons,
    });

    const hoverItemTextClasses = classNames({
      [classes.hoverItemText]: !isNewDropdown,

      ["flex"]: isNewDropdown,
    });

    const buttonIconAndTextClasses = classNames({
      [classes.buttonIconAndText]: !isNewDropdown,
    });

    const dividerClasses = classNames({ [classes.divider]: !isNewDropdown });

    const googleDriveInnerDivClasses = classNames({
      [classes.googleDriveInnerDiv]: !isNewDropdown,
    });

    const innerIconClasses = classNames({
      [classes.innerIcon]: !isNewDropdown,
    });

    const iconSvgContainerClasses = classNames({
      [classes.iconSvgContainer]: !isNewDropdown,

      ["flex"]: isNewDropdown,
    });

    const hoverItemContainerClassesGoogleDrive = classNames({
      [hoverItemContainerClasses]: !isShowIconsInBar,
      [classes.icon]: isShowIconsInBar,
      [classes.iconButtonSpaceContainer]: reduceSpacingBetweenIcons,
      [classes.iconButtonMarginContainer]: compactSpacingBetweenIcons,
      [classes.compactIcon]: showCompactIcons,
    });

    const isDsV2 = dsVersion === "2.0";

    const iconButtonOptions = getIconButtonOptions({
      testId,
      iconButtonSize,
      iconButtonVariant,
      iconButtonType,
      iconButtonVariantV2,
      disableAllOptions,
      showPlaceholderFileIcon,
      isAudioDisabled,
      isSharePointV2Enabled,
      iconButtonStyles,
      dsVersion,
    });
    const getIconButton = key => {
      return _.find(iconButtonOptions, { key: key })?.icon;
    };

    const captureOptionIcon = getIconButton(key);

    if (key === GOOGLE_DRIVE && !ACLStore.can(ENABLE_GOOGLE_DRIVE)) return;
    if (key === ONE_DRIVE && !ACLStore.can(ENABLE_ONE_DRIVE)) return;

    const resolvedLabel = !isLabelLocalized ? t(label) : label;

    const handleKeyDownonFilePickerOption = e => {
      onEnterOrSpaceKeyDownWithCodeMapping({
        event: e,
        CODE_MAPPING,
        cb: this.onFilePickerOptionClick.bind(this, e, () =>
          this.onClickDropdownOption({ key })
        ),
      });
    };

    const handleKeyDownOnSharePickerOption = e => {
      onEnterOrSpaceKeyDownWithCodeMapping({
        event: e,
        CODE_MAPPING,
        cb: this.onFilePickerOptionClick.bind(this, e, () => {
          this.onSharePointClick();
        }),
      });
    };

    const renderDocumentsSubMenu = ({
      itemKey,
      itemLabel,
      itemIsLabelLocalized,
      documentOptions,
      itemIndex,
    }) => (
      <div
        key={`${itemKey}-${itemIndex}`}
        className={hoverItemContainerClassesGoogleDrive}
      >
        <Dropdown
          overlay={
            <DropdownMenu
              options={getLocalizedOptions({
                options: _.filter(
                  documentOptions,
                  option =>
                    _.isEmpty(accept) || _.includes(accept, option.mimeType)
                ),
                t,
              })}
              onClick={this.onClickDropdownOption}
            />
          }
        >
          <ConditionalWrapper
            condition={!isTablet}
            type="wrapperAsElement"
            wrapper={
              <Tooltip
                tooltip={!itemIsLabelLocalized ? t(itemLabel) : itemLabel}
                placement="top"
                showArrow={true}
              />
            }
          >
            {getIconButton(itemKey)}
          </ConditionalWrapper>
        </Dropdown>
      </div>
    );

    const handleKeyDownGooglePhotos = e => {
      onEnterOrSpaceKeyDownWithCodeMapping({
        event: e,
        CODE_MAPPING,
        cb: this.onGooglePhotosClicked,
      });
    };

    const isTablet = isTabletByUserAgent();

    return key === "add_evidence" ? (
      isShowIconsInBar ? (
        <ConditionalWrapper
          condition={!isTablet}
          type="wrapperAsElement"
          wrapper={
            <Tooltip tooltip={resolvedLabel} placement="top" showArrow={true} />
          }
        >
          <IconButton
            _legacy_variant={"plain"}
            variant="neutral"
            type="plain"
            size={"small"}
            onClick={() => {
              if (!isNewDropdown) this.onClickDropdownOption({ key });
            }}
            isCompact={true}
            icon={
              !isNewDropdown &&
              (showV2Icons ? (
                getIconButton(key)
              ) : (
                <div className={classes.innerIcon}>
                  <ResourcesLineIcon width={16} height={14} />
                </div>
              ))
            }
            className={iconClasses}
          />
        </ConditionalWrapper>
      ) : (
        <div
          className={hoverItemContainerClasses}
          key={`${key}-${index}`}
          onClick={() => {
            if (!isNewDropdown) this.onClickDropdownOption({ key });
          }}
        >
          {!isNewDropdown && (
            <div className={classes.innerIcon}>
              {icon ? (
                icon
              ) : (
                <ToddleIcon width={16} height={16} fill={colors.neutral400} />
              )}
            </div>
          )}
          <div className={hoverItemTextClasses}>
            {!isLabelLocalized ? t(`${label}`) : label}
          </div>
        </div>
      )
    ) : key === "upload_device" || key === "upload_image" ? (
      <React.Fragment key={`${key}-${index}`}>
        <div className={isShowIconsInBar && iconClasses}>
          {this.renderFileDropzoneComponent({
            dropZoneStyle: isNewDropdown ? dropzoneStyle : customDropZoneStyle,
            accept: acceptTypes || accept,
            uploadType: type,
            isDialogueBoxEnabled,
            dialogueBoxInfo,
            renderComponent: isShowIconsInBar ? (
              <ConditionalWrapper
                condition={!isTablet}
                type="wrapperAsElement"
                wrapper={
                  <Tooltip
                    tooltip={resolvedLabel}
                    placement="top"
                    showArrow={true}
                  />
                }
              >
                {!isNewDropdown &&
                  (showV2Icons ? (
                    getIconButton(key)
                  ) : dropDownOptionButton ? (
                    dropDownOptionButton(key)
                  ) : (
                    <IconButton
                      _legacy_variant="plain"
                      variant="neutral"
                      type="plain"
                      isCompact={true}
                      className={classes.innerIcon}
                      icon={<UploadCloudOutlined variant="subtle" />}
                    />
                  ))}
              </ConditionalWrapper>
            ) : (
              <div
                ref={this.innerDropzoneRef}
                id={`upload_device`}
                className={hoverItemContainerClasses}
                onClick={this.onFilePickerOptionClick}
                tabIndex={0}
                role="button"
                onKeyDown={handleKeyDownonFilePickerOption}
              >
                <div className={buttonIconAndTextClasses}>
                  {!isNewDropdown && (
                    <div className={classes.innerIcon}>
                      {icon ? icon : <ImageIcon height={16} width={16} />}
                    </div>
                  )}
                  <div className={hoverItemTextClasses}>
                    {!isLabelLocalized
                      ? t(label || "common:upload_device")
                      : label}
                  </div>
                </div>
              </div>
            ),
          })}
        </div>
      </React.Fragment>
    ) : key === "upload_folder" ? (
      <React.Fragment key={`${key}-${index}`}>
        <div className={isShowIconsInBar && iconClasses}>
          {this.renderFolderDropzoneComponent({
            dropZoneStyle: isNewDropdown ? dropzoneStyle : customDropZoneStyle,
            accept: acceptTypes || accept,
            uploadType: type,
            isDialogueBoxEnabled,
            dialogueBoxInfo,
            renderComponent: isShowIconsInBar ? (
              <Tooltip tooltip={resolvedLabel} placement="top" showArrow={true}>
                {!isNewDropdown &&
                  (showV2Icons ? (
                    getIconButton(key)
                  ) : dropDownOptionButton ? (
                    dropDownOptionButton(key)
                  ) : (
                    <IconButton
                      _legacy_variant="plain"
                      variant="neutral"
                      type="plain"
                      isCompact={true}
                      className={classes.innerIcon}
                      icon={<UploadCloudOutlined />}
                    />
                  ))}
              </Tooltip>
            ) : (
              <div
                ref={this.innerFolderDropzoneRef}
                id={`upload_folder`}
                className={hoverItemContainerClasses}
                onClick={this.onFilePickerOptionClick}
              >
                <div className={buttonIconAndTextClasses}>
                  {!isNewDropdown && (
                    <div className={classes.innerIcon}>
                      {icon ? icon : <ImageIcon height={16} width={16} />}
                    </div>
                  )}
                  <div className={hoverItemTextClasses}>
                    {!isLabelLocalized
                      ? t(label || "common:upload_folder")
                      : label}
                  </div>
                </div>
              </div>
            ),
          })}
        </div>
      </React.Fragment>
    ) : isCaptureOption ? (
      isShowIconsInBar ? (
        <ConditionalWrapper
          condition={!isTablet}
          type="wrapperAsElement"
          wrapper={
            <Tooltip tooltip={resolvedLabel} placement="top" showArrow={true} />
          }
        >
          <div
            className={iconClasses}
            onClick={() => {
              if (!isNewDropdown) this.toggleCaptureScreen({ key, disabled });
            }}
            key={`${key}-${index}`}
          >
            {!isNewDropdown &&
              (showV2Icons ? (
                getIconButton(key)
              ) : dropDownOptionButton ? (
                dropDownOptionButton(key)
              ) : (
                <IconButton
                  _legacy_variant="plain"
                  variant="neutral"
                  type="plain"
                  isCompact={true}
                  className={classes.innerIcon}
                  icon={<UploadCloudOutlined />}
                />
              ))}
          </div>
        </ConditionalWrapper>
      ) : (
        <div
          className={hoverItemContainerClasses}
          data-test-id={`${testId}-toggleCapture`}
          onClick={() => {
            if (!isNewDropdown) this.toggleCaptureScreen({ key, disabled });
          }}
          key={`${key}-${index}`}
        >
          {!isNewDropdown && (
            <div className={classes.innerIcon}>
              {icon ? icon : captureOptionIcon}
            </div>
          )}
          <div className={hoverItemTextClasses}>{t(label)}</div>
        </div>
      )
    ) : key === "add_link" ? (
      isShowIconsInBar ? (
        <ConditionalWrapper
          condition={!isTablet}
          type="wrapperAsElement"
          wrapper={
            <Tooltip tooltip={resolvedLabel} placement="top" showArrow={true} />
          }
        >
          <IconButton
            _legacy_variant={"plain"}
            variant="neutral"
            type="plain"
            size={"small"}
            isCompact={!showIconCardV2}
            onClick={() => {
              if (!isNewDropdown && !disabled) {
                this.setState({ showLinkModal: true });
              }
            }}
            key={`${key}-${index}`}
            icon={
              !isNewDropdown &&
              (showV2Icons ? (
                getIconButton(key)
              ) : (
                <div className={classes.innerIcon}>
                  <LinkIconV2 height={20} width={20} />
                </div>
              ))
            }
            disabled={showIconCardV2 ? disableAllOptions : false}
            className={iconClasses}
          />
        </ConditionalWrapper>
      ) : (
        <div
          className={hoverItemContainerClasses}
          onClick={() => {
            if (!isNewDropdown) {
              this.setState({ showLinkModal: true });
            }
          }}
          key={`${key}-${index}`}
        >
          {!isNewDropdown && (
            <div className={classes.innerIcon}>
              {icon ? (
                icon
              ) : (
                <LinkOutlined size={"xxx-small"} variant={"subtle"} />
              )}
            </div>
          )}
          <div className={hoverItemTextClasses}>{t(label)}</div>
        </div>
      )
    ) : key === GOOGLE_DRIVE ? (
      <div
        key={`${key}-${index}`}
        className={hoverItemContainerClassesGoogleDrive}
        tabIndex={0}
        onKeyDown={handleKeyDownonFilePickerOption}
      >
        {this.renderGooglePickerComponent({
          renderComponent: isShowIconsInBar ? (
            <ConditionalWrapper
              condition={!isTablet}
              type="wrapperAsElement"
              wrapper={
                <Tooltip
                  tooltip={resolvedLabel}
                  placement="top"
                  showArrow={true}
                />
              }
            >
              {!isNewDropdown &&
                (showV2Icons ? (
                  getIconButton(key)
                ) : (
                  <IconButton
                    _legacy_variant={"plain"}
                    variant="neutral"
                    type="plain"
                    size={"small"}
                    isCompact={true}
                    icon={<GoogleDriveIconV2 height={18} width={16} />}
                  />
                ))}
            </ConditionalWrapper>
          ) : (
            <div
              className={googleDriveInnerDivClasses}
              id={GOOGLE_DRIVE}
              onClick={this.onFilePickerOptionClick}
            >
              {!isNewDropdown && (
                <div className={innerIconClasses}>
                  {icon ? icon : <GoogleDriveIcon />}
                </div>
              )}
              <div className={hoverItemTextClasses}>{t(label)}</div>
            </div>
          ),
          classStyle: iconSvgContainerClasses,
          accept: acceptTypes || accept,
        })}
      </div>
    ) : key === GOOGLE_PHOTOS_PICKER && enableGooglePhotosPicker() ? (
      <div
        key={`${key}-${index}`}
        className={hoverItemContainerClassesGoogleDrive}
        tabIndex={0}
        onClick={this.onGooglePhotosClicked}
        onKeyDown={handleKeyDownGooglePhotos}
      >
        <GooglePhotosPicker
          renderComponent={
            isShowIconsInBar ? (
              <ConditionalWrapper
                condition={!isTablet}
                type="wrapperAsElement"
                wrapper={
                  <Tooltip
                    tooltip={!isLabelLocalized ? t(label) : label}
                    placement="top"
                    showArrow={true}
                  />
                }
              >
                {!isNewDropdown &&
                  (showV2Icons ? (
                    getIconButton(key)
                  ) : (
                    <IconButton
                      _legacy_variant={"plain"}
                      variant="neutral"
                      type="plain"
                      size={"small"}
                      isCompact={true}
                      icon={<GooglePhotosBrand size={"x-small"} />}
                    />
                  ))}
              </ConditionalWrapper>
            ) : (
              <div
                className={googleDriveInnerDivClasses}
                id={GOOGLE_PHOTOS_PICKER}
                onClick={this.onFilePickerOptionClick}
              >
                {!isNewDropdown && (
                  <div className={innerIconClasses}>
                    {icon ? icon : <GooglePhotosBrand />}
                  </div>
                )}
                <div className={hoverItemTextClasses}>{t(label)}</div>
              </div>
            )
          }
          ref={this.setGooglePhotosPickerRef}
          classStyle={iconSvgContainerClasses}
          updateFilesCount={this.updateFilesCount}
          onContentLoaded={this.onContentUploaded}
          parentId={parentId}
          parentType={parentType}
          shouldUpload={false}
          maxSize={maxSize}
        />
      </div>
    ) : key === ONE_DRIVE ? (
      <div
        key={`${key}-${index}`}
        className={hoverItemContainerClassesGoogleDrive}
      >
        {this.renderMicrosoftPickerComponent({
          renderComponent: isShowIconsInBar ? (
            <ConditionalWrapper
              condition={!isTablet}
              type="wrapperAsElement"
              wrapper={
                <Tooltip
                  tooltip={resolvedLabel}
                  placement="top"
                  showArrow={true}
                />
              }
            >
              {!isNewDropdown &&
                (showV2Icons ? (
                  getIconButton(key)
                ) : (
                  <IconButton
                    _legacy_variant={"plain"}
                    variant="neutral"
                    type="plain"
                    size={"small"}
                    isCompact={true}
                    icon={icon ? icon : <OneDriveIcon height={12} width={18} />}
                  />
                ))}
            </ConditionalWrapper>
          ) : (
            <div
              className={googleDriveInnerDivClasses}
              id={ONE_DRIVE}
              onClick={this.onFilePickerOptionClick}
            >
              {!isNewDropdown && (
                <div className={innerIconClasses}>
                  {icon ? icon : <OneDriveIcon />}
                </div>
              )}
              <div className={hoverItemTextClasses}>{t(label)}</div>
            </div>
          ),
          classStyle: iconSvgContainerClasses,
          accept: acceptTypes || accept,
        })}
      </div>
    ) : key === CAPTURE_VOICE ? (
      <div className={iconClasses} id={CAPTURE_VOICE} key={`${key}-${index}`}>
        <VoiceRecorderV2
          title={t("common:record_audio")}
          buttonComponent={getIconButton(key)}
          updatePost={this.updatePost}
          tooltip={!isTablet ? resolvedLabel : null} // wrapping tooltip here is not working as expected so wrapping buttonComponent instead
          reloadText={t(reloadText)}
          submitText={t(submitText)}
          audioRecordingLimit={audioRecordingLimit}
          testId={testId}
        />
      </div>
    ) : key === CAPTURE_MEDIA ? (
      <Dropdown
        overlay={
          <DropdownMenu
            options={getCaptureMediaOption({ t })}
            onClick={e => {
              this.toggleCaptureScreen({ key: e.key });
            }}
          />
        }
        placement={"topLeft"}
        overlayStyle={customOverlayStyle}
      >
        <div
          className={iconClasses}
          id={`capture`}
          onClick={() => {}}
          key={`${key}-${index}`}
        >
          <ConditionalWrapper
            condition={!isTablet}
            type="wrapperAsElement"
            wrapper={
              <Tooltip
                tooltip={resolvedLabel}
                placement="top"
                showArrow={true}
              />
            }
          >
            {getIconButton(key)}
          </ConditionalWrapper>
        </div>
      </Dropdown>
    ) : key === "create_template_multipage" ? (
      <div
        className={hoverItemContainerClasses}
        onClick={() => {
          if (!isNewDropdown) {
            this.setState({ showWorkbookModal: true });
          }
        }}
        key={`${key}-${index}`}
      >
        {showV2Icons ? (
          <Tooltip
            tooltip={label ? t(label) : t("common:create_workbook")}
            placement="top"
            key={`${key}-${index}`}
            showArrow={true}
          >
            {getIconButton(key)}
          </Tooltip>
        ) : (
          <React.Fragment key={`${key}-${index}`}>
            {!isNewDropdown ? (
              <WorkbookOutlined size="xx-small" variant="subtle" />
            ) : null}
            <div className={hoverItemTextClasses}>
              {label ? t(label) : t("common:create_workbook")}
            </div>
          </React.Fragment>
        )}
      </div>
    ) : key === "add_note" ? (
      isShowIconsInBar ? (
        <ConditionalWrapper
          condition={!isTablet}
          type="wrapperAsElement"
          wrapper={
            <Tooltip tooltip={resolvedLabel} placement="top" showArrow={true} />
          }
        >
          <div
            className={iconClasses}
            onClick={!isNewDropdown ? this.toddleAddNoteDialogue : null}
            key={`${key}-${index}`}
          >
            {!isNewDropdown &&
              (showV2Icons ? (
                getIconButton(key)
              ) : (
                <div className={classes.innerIcon}>
                  <NoteIcon height={16} width={16} />
                </div>
              ))}
          </div>
        </ConditionalWrapper>
      ) : (
        <div
          className={hoverItemContainerClasses}
          onClick={!isNewDropdown ? this.toddleAddNoteDialogue : null}
          key={`${key}-${index}`}
        >
          {!isNewDropdown && (
            <div className={classes.innerIcon}>
              <NoteIcon fill={colors.neutral400} width={16} height={16} />
            </div>
          )}
          <div className={hoverItemTextClasses}>{t(label)}</div>
        </div>
      )
    ) : key === SHAREPOINT_DRIVE ? (
      <div
        key={`${key}-${index}`}
        className={hoverItemContainerClassesGoogleDrive}
        tabIndex={0}
        onKeyDown={handleKeyDownOnSharePickerOption}
      >
        {this.renderSharepointPickerComponent({
          renderComponent: isShowIconsInBar ? (
            <ConditionalWrapper
              condition={!isTablet}
              type="wrapperAsElement"
              wrapper={
                <Tooltip
                  tooltip={<div>{resolvedLabel}</div>}
                  placement="top"
                  showArrow={true}
                />
              }
            >
              <div
                id={SHAREPOINT_DRIVE}
                onClick={!isNewDropdown ? this.onSharePointClick : null}
                key={`${key}-${index}`}
                className={classes.iconContainer}
              >
                {!isNewDropdown &&
                  (showV2Icons ? (
                    <div>{getIconButton(key)}</div>
                  ) : (
                    <div className={innerIconClasses}>
                      {icon ? icon : <OneDriveIcon />}
                    </div>
                  ))}
              </div>
            </ConditionalWrapper>
          ) : (
            <div
              className={classes.sharepointInnerDiv}
              id={SHAREPOINT_DRIVE}
              onClick={e => {
                if (!isNewDropdown) {
                  this.onFilePickerOptionClick(e, this.onSharePointClick);
                }
              }}
            >
              {!isNewDropdown && (
                <div className={innerIconClasses}>
                  {icon ? icon : <OneDriveIcon />}
                </div>
              )}
              <div className={hoverItemTextClasses}>{t(label)}</div>
            </div>
          ),
          classStyle: iconSvgContainerClasses,
          accept: acceptTypes || accept,
        })}
      </div>
    ) : key === "GOOGLE_DOCUMENTS" && isShowIconsInBar ? (
      renderDocumentsSubMenu({
        itemKey: key,
        itemLabel: label,
        itemIsLabelLocalized: isLabelLocalized,
        documentOptions: GOOGLE_OPTIONS,
        itemIndex: index,
      })
    ) : key === "MICROSOFT_DOCUMENTS" && isShowIconsInBar ? (
      renderDocumentsSubMenu({
        itemKey: key,
        itemLabel: label,
        itemIsLabelLocalized: isLabelLocalized,
        documentOptions: MICROSOFT_OPTIONS,
        itemIndex: index,
      })
    ) : key === SEARCH_ON_PIXABAY ? (
      <div
        className={hoverItemContainerClasses}
        key={`${key}-${index}`}
        onClick={() => {
          if (!isNewDropdown) {
            this.onClickDropdownOption({ key });
          }
        }}
      >
        {!isNewDropdown && (icon ? icon : <SearchOutlined />)}
        <div className={hoverItemTextClasses}>
          {!isLabelLocalized ? t(`${label}`) : label}
        </div>
      </div>
    ) : type === "divider" ? (
      <div className={dividerClasses} key={`${key}-${index}`} />
    ) : isShowIconsInBar ? (
      <ConditionalWrapper
        condition={!isTablet}
        type="wrapperAsElement"
        wrapper={
          <Tooltip tooltip={resolvedLabel} placement="top" showArrow={true} />
        }
      >
        <div
          className={iconClasses}
          key={`${key}-${index}`}
          onClick={() => {
            if (!isNewDropdown) {
              this.onClickDropdownOption({ key });
            }
          }}
        >
          {!isNewDropdown &&
            (showV2Icons ? (
              getIconButton("select_resource")
            ) : (
              <div className={classes.innerIcon}>
                {icon ? icon : <ToddleIcon width={16} height={16} />}
              </div>
            ))}
        </div>
      </ConditionalWrapper>
    ) : (
      <div
        className={hoverItemContainerClasses}
        key={`${key}-${index}`}
        onClick={() => {
          if (!isNewDropdown) {
            this.onClickDropdownOption({ key });
          }
        }}
      >
        {!isNewDropdown &&
          (icon ? (
            icon
          ) : (
            <ToddleIcon width={16} height={16} fill={colors.neutral400} />
          ))}
        <div className={hoverItemTextClasses}>
          {!isLabelLocalized ? t(`${label}`) : label}
        </div>
      </div>
    );
  };

  getPermBasedOnParentType = parentType => {
    switch (parentType) {
      case "STUDENT_FILES":
        return ACLStore.can(ENABLE_STUDENT_FILES_FOLDER_UPLOAD);
      case "STUDENT_DRIVE":
        return ACLStore.can(ENABLE_STUDENT_DRIVE_FOLDER_UPLOAD);
      case "POLICIES_AND_RESOURCES":
        return ACLStore.can(ENABLE_EDUCATOR_CENTRE_FOLDER_UPLOAD);
      default:
        return false;
    }
  };

  buildDropdownMenuOptions = options => {
    const {
      t,
      enableShortcut,
      parentType,
      appendIndexWithKey,
      sourceType = "",
      curriculumProgramType = "",
      grade,
    } = this.props;

    // Build a key→type map so onClickDropdownOption can retrieve uploadType for
    // upload_device / upload_image options when the hidden picker path is active.
    this._keyToType = {};

    // When the studentTemplate field also accepts PDFs (PDFTron edit or
    // workbook conversion enabled), upload_device is no longer images-only,
    // so replace the JSON-default "upload_images_from_device" label with the
    // generic "upload_device". Mirrors the legacy icon-bar override.
    const shouldRelabelUploadDevice =
      sourceType === "STUDENT_TEMPLATE" &&
      (canEditPdfInPdftron({ curriculumProgramType, grade }) ||
        shouldConverPdfToWorkbook({ curriculumProgramType, grade }));

    const resolveOptionLabel = option => {
      if (option.isLabelLocalized) return option.label;
      const labelKey =
        shouldRelabelUploadDevice && option.key === "upload_device"
          ? "common:upload_device"
          : option.label;
      return t(labelKey);
    };

    const formatOption = (option, index) => {
      if (!option) return null;

      // Filter by ACL permissions
      if (option.key === GOOGLE_DRIVE && !ACLStore.can(ENABLE_GOOGLE_DRIVE))
        return null;
      if (option.key === ONE_DRIVE && !ACLStore.can(ENABLE_ONE_DRIVE))
        return null;
      if (
        option.key === UPLOAD_FOLDER &&
        !this.getPermBasedOnParentType(parentType)
      )
        return null;

      // Pass dividers through as-is
      if (option.isDivider) {
        return { ...option };
      }

      const label = resolveOptionLabel(option);

      const disabledTooltip = option.disabledTooltip ? (
        <div className={classes.disabledTooltip}>{option.disabledTooltip}</div>
      ) : null;

      const formattedKey = appendIndexWithKey
        ? `${option.key}-${index}`
        : option.key;

      // Recursively format submenu / item group children
      if (option.isSubMenu || option.isItemGroup) {
        const formattedChildren = _.compact(
          _.map(_.get(option, "options", []), formatOption)
        );
        if (_.isEmpty(formattedChildren)) return null;
        return {
          ...option,
          key: formattedKey,
          label,
          options: formattedChildren,
          disabledTooltip,
        };
      }

      // Record type for upload options so onClickDropdownOption can pass it through
      if (option.type) this._keyToType[formattedKey] = option.type;

      const suffix =
        enableShortcut && option.keyboardShortcut ? (
          <Badge
            dsVersion="2.0"
            type={"shortcut"}
            value={option.keyboardShortcut}
            shape="square"
          />
        ) : null;

      return {
        ...option,
        key: formattedKey,
        label,
        disabledTooltip,
        suffix,
      };
    };

    return _.compact(_.map(options, formatOption));
  };

  getDropdownStructure = dropdownOptions => {
    const {
      testId,
      dsVersion,
      isSearchEnabled,
      dropdownMenuSize,
      overlayHeight,
      dropdownMenuStyle,
      hasMultilineOptions,
    } = this.props;

    return (
      <DropdownMenu
        testId={testId}
        onClick={this.onClickDropdownOption}
        options={this.buildDropdownMenuOptions(dropdownOptions)}
        dsVersion={dsVersion}
        className={classes.newDropdownMenu}
        isSearchEnabled={isSearchEnabled}
        onSearchTextChange={this.handleSearchTextChange}
        overlayHeight={overlayHeight}
        style={dropdownMenuStyle}
        size={dropdownMenuSize}
        hasMultilineOptions={hasMultilineOptions}
      />
    );
  };

  renderGooglePickerComponent = ({
    renderComponent,
    classStyle = "",
    accept: acceptOverride,
  } = {}) => {
    const {
      accept,
      portalType,
      maxSize,
      multiselect,
      exportAsPdf,
      onMultipleFilesUploaded,
      parentId,
      parentType,
      sourceType,
      enableShareModal,
      defaultExportType,
      attachmentExportOptions,
      customizedFile,
      disabled,
      excludeFileExtensionsList,
      customFilterFilesHandler,
    } = this.props;

    return (
      <GooglePicker
        accept={acceptOverride || accept}
        portalType={portalType}
        maxSize={maxSize}
        renderComponent={renderComponent}
        pickerType="GoogleDrive"
        classStyle={classStyle}
        updateFilesCount={this.updateFilesCount}
        multiselect={multiselect}
        exportAsPdf={exportAsPdf}
        onSingleContentUploaded={this.onContentUploaded}
        onMultipleFilesUploaded={onMultipleFilesUploaded}
        onFailedAllowedMimeType={this.onFailedAllowedMimeType}
        thumbnailSize={"w248-h200"}
        parentId={parentId}
        parentType={parentType}
        sourceType={sourceType}
        enableShareModal={enableShareModal}
        defaultExportType={defaultExportType}
        onDropContent={this.props.onDropContent}
        setInnerGooglePickerRef={this.setInnerGooglePickerRef}
        attachmentExportOptions={attachmentExportOptions}
        customizedFile={customizedFile}
        disabled={disabled}
        excludeFileExtensionsList={excludeFileExtensionsList}
        customFilterFilesHandler={customFilterFilesHandler}
        shouldReturnSignedUrl={this.props.shouldReturnSignedUrl}
        isIncreasedUploadLimit={this.props.isIncreasedUploadLimit}
      />
    );
  };

  renderMicrosoftPickerComponent = ({
    renderComponent,
    classStyle = "",
    accept: acceptOverride,
  } = {}) => {
    const {
      accept,
      portalType,
      maxSize,
      multiselect,
      exportAsPdf,
      onMultipleFilesUploaded,
      parentId,
      parentType,
      sourceType,
      enableShareModal,
      defaultExportType,
      attachmentExportOptions,
      customizedFile,
      disabled,
      excludeFileExtensionsList,
      customFilterFilesHandler,
    } = this.props;

    return (
      <MicrosoftPicker
        renderComponent={renderComponent}
        pickerType="GoogleDrive"
        classStyle={classStyle}
        updateFilesCount={this.updateFilesCount}
        multiselect={multiselect}
        onSingleContentUploaded={this.onContentUploaded}
        onFailedAllowedMimeType={this.onFailedAllowedMimeType}
        thumbnailSize={"w248-h200"}
        parentId={parentId}
        parentType={parentType}
        exportAsPdf={exportAsPdf}
        portalType={portalType}
        accept={acceptOverride || accept}
        onMultipleFilesUploaded={onMultipleFilesUploaded}
        maxSize={maxSize}
        sourceType={sourceType}
        enableShareModal={enableShareModal}
        defaultExportType={defaultExportType}
        onDropContent={this.props.onDropContent}
        setInnerPickerRef={this.setInnerMicrosoftPickerRef}
        attachmentExportOptions={attachmentExportOptions}
        customizedFile={customizedFile}
        disabled={disabled}
        excludeFileExtensionsList={excludeFileExtensionsList}
        customFilterFilesHandler={customFilterFilesHandler}
        isIncreasedUploadLimit={this.props.isIncreasedUploadLimit}
      />
    );
  };

  renderSharepointPickerComponent = ({
    renderComponent,
    classStyle = "",
    accept: acceptOverride,
  } = {}) => {
    const {
      accept,
      portalType,
      maxSize,
      multiselect,
      exportAsPdf,
      onMultipleFilesUploaded,
      parentId,
      parentType,
      sourceType,
      enableShareModal,
      defaultExportType,
      attachmentExportOptions,
      excludeFileExtensionsList,
      customFilterFilesHandler,
      userType,
    } = this.props;

    const sharedProps = {
      renderComponent,
      classStyle,
      ref: this.setSharepointPickerRef,
      updateFilesCount: this.updateFilesCount,
      onSingleContentUploaded: this.onContentUploaded,
      onFailedAllowedMimeType: this.onFailedAllowedMimeType,
      parentId,
      parentType,
      exportAsPdf,
      portalType,
      accept: acceptOverride || accept,
      onMultipleFilesUploaded,
      maxSize,
      sourceType,
      enableShareModal,
      defaultExportType,
      onDropContent: this.props.onDropContent,
      attachmentExportOptions,
      multiSelect: multiselect,
      excludeFileExtensionsList,
      customFilterFilesHandler,
      shouldReturnSignedUrl: this.props.shouldReturnSignedUrl,
      isIncreasedUploadLimit: this.props.isIncreasedUploadLimit,
    };

    return enableSharepointPickerV2ForUser(userType) ? (
      <SharepointPickerV2 {...sharedProps} />
    ) : (
      <SharepointPicker {...sharedProps} />
    );
  };

  renderFileDropzoneComponent = ({
    renderComponent,
    dropZoneStyle: dropZoneStyleOverride,
    accept: acceptOverride,
    uploadType,
    isDialogueBoxEnabled,
    dialogueBoxInfo,
  } = {}) => {
    const {
      maxSize,
      portalType,
      multiselect,
      dropzoneClass,
      parentId,
      parentType,
      onMultipleFilesUploaded,
      excludeFileExtensionsList,
      customFilterFilesHandler,
      testId,
    } = this.props;

    return (
      // do not remove this ref. This ref is used for the ability to paste a copied image in the chat
      <DropzoneComponent
        ref={this.dropzoneRef}
        maxSize={maxSize}
        portalType={portalType}
        multiple={multiselect}
        dropzoneClass={dropzoneClass}
        dropZoneStyle={dropZoneStyleOverride || dropzoneStyle}
        renderComponent={renderComponent}
        onSingleContentUploaded={this.onContentUploaded}
        onContentUploaded={onMultipleFilesUploaded}
        updateFilesCount={this.updateFilesCount}
        parentId={parentId}
        parentType={parentType}
        accept={acceptOverride || this.props.accept}
        uploadType={uploadType}
        isDialogueBoxEnabled={isDialogueBoxEnabled}
        dialogueBoxInfo={dialogueBoxInfo}
        onDropContent={this.props.onDropContent}
        customizedFileObject={this.customizedFileObject}
        customizedFile={this.props.customizedFile}
        excludeFileExtensionsList={excludeFileExtensionsList}
        customFilterFilesHandler={customFilterFilesHandler}
        testId={testId}
        shouldReturnSignedUrl={this.props.shouldReturnSignedUrl}
        isIncreasedUploadLimit={this.props.isIncreasedUploadLimit}
      />
    );
  };

  renderFolderDropzoneComponent = ({
    renderComponent,
    dropZoneStyle: dropZoneStyleOverride,
    accept: acceptOverride,
    uploadType,
    isDialogueBoxEnabled,
    dialogueBoxInfo,
  } = {}) => {
    const {
      maxSize,
      portalType,
      multiselect,
      dropzoneClass,
      parentId,
      moduleId,
      parentType,
      isRootDirectory,
      onMultipleFoldersUploaded,
      onCreateResourceMapping,
      testId,
    } = this.props;

    return (
      <DropzoneComponent
        maxSize={maxSize}
        portalType={portalType}
        multiple={multiselect}
        dropzoneClass={dropzoneClass}
        dropZoneStyle={dropZoneStyleOverride || dropzoneStyle}
        renderComponent={renderComponent}
        onSingleContentUploaded={this.onContentUploaded}
        onContentUploaded={onMultipleFoldersUploaded}
        updateFilesCount={this.updateFilesCount}
        parentId={parentId || moduleId}
        parentType={parentType}
        isRootDirectory={isRootDirectory}
        accept={acceptOverride || this.props.accept}
        uploadType={uploadType}
        isDialogueBoxEnabled={isDialogueBoxEnabled}
        dialogueBoxInfo={dialogueBoxInfo}
        onDropContent={this.props.onDropContent}
        customizedFileObject={this.customizedFileObject}
        customizedFile={this.props.customizedFile}
        isFolderPicker={true}
        shouldAllowConflictingLabels={false}
        onCreateResourceMapping={onCreateResourceMapping}
        visibleTo={this.props.visibleTo}
        testId={testId}
      />
    );
  };

  renderHiddenPickerComponents = filteredDropdownOptions => {
    const { parentType, userType } = this.props;

    const { keys: flatKeys, acceptMap } = extractAllKeysWithAccept(
      filteredDropdownOptions
    );

    return (
      <div className={classes.hiddenPickerContainer}>
        {/* File upload dropzone — ref used for paste-image-in-chat feature, do not remove */}
        {(flatKeys.has(UPLOAD_FROM_DEVICE) || flatKeys.has(UPLOAD_IMAGE)) &&
          this.renderFileDropzoneComponent({
            renderComponent: <div ref={this.innerDropzoneRef} />,
            accept: flatKeys.has(UPLOAD_FROM_DEVICE)
              ? acceptMap.get(UPLOAD_FROM_DEVICE)
              : acceptMap.get(UPLOAD_IMAGE),
          })}

        {/* Folder upload dropzone */}
        {flatKeys.has(UPLOAD_FOLDER) &&
          this.getPermBasedOnParentType(parentType) &&
          this.renderFolderDropzoneComponent({
            renderComponent: <div ref={this.innerFolderDropzoneRef} />,
            accept: acceptMap.get(UPLOAD_FOLDER),
          })}

        {/* Google Drive picker */}
        {flatKeys.has(GOOGLE_DRIVE) &&
          ACLStore.can(ENABLE_GOOGLE_DRIVE) &&
          this.renderGooglePickerComponent({
            renderComponent: <div />,
            accept: acceptMap.get(GOOGLE_DRIVE),
          })}

        {/* Microsoft OneDrive picker */}
        {flatKeys.has(ONE_DRIVE) &&
          ACLStore.can(ENABLE_ONE_DRIVE) &&
          !enableSharepointPickerV2ForUser(userType) &&
          this.renderMicrosoftPickerComponent({
            renderComponent: <div />,
            accept: acceptMap.get(ONE_DRIVE),
          })}

        {/* SharePoint picker (V2 or V1 based on user type) */}
        {flatKeys.has(SHAREPOINT_DRIVE) &&
          this.renderSharepointPickerComponent({
            renderComponent: <div />,
            accept: acceptMap.get(SHAREPOINT_DRIVE),
          })}

        {/* Google Photos picker */}
        {flatKeys.has(GOOGLE_PHOTOS_PICKER) && enableGooglePhotosPicker() && (
          <GooglePhotosPicker
            ref={this.setGooglePhotosPickerRef}
            renderComponent={<div />}
            classStyle=""
            updateFilesCount={this.updateFilesCount}
            onContentLoaded={this.onContentUploaded}
            parentId={this.props.parentId}
            parentType={parentType}
            shouldUpload={false}
            maxSize={this.props.maxSize}
          />
        )}
      </div>
    );
  };

  createDropdownComponent = ({ type }) => {
    const { createButtonComponentConfig } = this.props;
    const {
      label,
      icon = "AddOutlined",
      size = "medium",
      variant = "outlined",
      buttonType = "outlined",
      iconType = "plain",
    } = createButtonComponentConfig;
    const { t, testId, disabled, disabledTooltip } = this.props;
    const Icon = ICONS[icon];

    const buttonLabel = label
      ? t(label)
      : t("common:add_a_with_label", { label: t("common:file") });

    switch (type) {
      case "ICON_BUTTON":
        return (
          <Button
            type={buttonType}
            testId={testId}
            icon={Icon ? <Icon /> : null}
            variant={variant}
            size={size}
          >
            {buttonLabel}
          </Button>
        );

      case "BUTTON_DISCLOSURE":
        return (
          <div>
            <Tooltip
              tooltip={disabledTooltip}
              overlayInnerStyle={styles.overlayInnerStyle}
            >
              <ButtonDisclosure
                testId={testId}
                icon={Icon ? <Icon /> : null}
                variant={variant}
                size={size}
                type={buttonType}
                disabled={disabled}
              >
                {buttonLabel}
              </ButtonDisclosure>
            </Tooltip>
          </div>
        );

      case "ICON_BUTTON_V2": {
        return (
          <IconButton
            testId={testId}
            icon={Icon ? <Icon /> : null}
            _legacy_variant={variant}
            variant={"neutral"}
            type={iconType}
            size={size}
          />
        );
      }
      default:
        return null;
    }
  };

  getButtonComponent = ({ type }) => {
    const {
      containerStyle = {},
      addButtonStyles = {},
      addMediaText,
      t,
    } = this.props;

    switch (type) {
      case "ICON_BUTTON":
      case "BUTTON_DISCLOSURE":
      case "ICON_BUTTON_V2":
        return this.createDropdownComponent({ type });

      default:
        return (
          <div className={classes.container} style={containerStyle}>
            <div className={classes.innerContainer}>
              <AddCircleIcon
                fill={
                  addButtonStyles.addIconColor
                    ? addButtonStyles.addIconColor
                    : colors.neutral400
                }
                width={20}
                height={20}
              />
              <div
                className={classes.addMediaText}
                style={addButtonStyles.addTextStyle}
              >
                {addMediaText ? addMediaText : t("common:add_attachments")}
              </div>
            </div>
          </div>
        );
    }
  };

  getDescriptionModal = () => {
    const { descriptionModalConfig = {}, parentType, t } = this.props;

    const {
      descriptionModalHeader = "",
      descriptionModalBody = "",
      DescriptionModalLeftFooter = null,
      onDescriptionModalClickOkay,
    } = descriptionModalConfig;

    const onCloseModal = () => {
      this.realClickRef.current = true;

      this.setState({
        showDescriptionModal: false,
      });
    };

    const onClickOkay = () => {
      this.setState({ showDescriptionModal: false });
      this.dropdownComponentRef.current.click();
      if (onDescriptionModalClickOkay) {
        onDescriptionModalClickOkay({ parentType });
      }
    };

    return (
      <Modal
        dsVersion="2.0"
        onClose={onCloseModal}
        width="480px"
        height="fit-content"
      >
        <Modal.Header title={descriptionModalHeader} hasSeparator={true} />
        <Modal.Body>{t(descriptionModalBody)}</Modal.Body>
        <Modal.Footer hasSeparator={true}>
          <div className={classes.modalFooter}>
            <div className={classes.leftModalFooter}>
              {DescriptionModalLeftFooter}
            </div>

            <div>
              <Button
                onClick={onClickOkay}
                variant="primary"
                size={"medium"}
                dsVersion="2.0"
                type="fill"
                shortcut={SHIFT_ENTER_SUBMIT_SHORTCUT}
              >
                {t("common:okay")}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  getSplitDropdownButton = filteredDropdownOptions => {
    const {
      buttonComponent,
      type,
      destroyPopupOnHide,
      dropdownPlacement,
      disabled,
    } = this.props;

    return (
      <SplitButtonDropdown
        overlay={this.getDropdownStructure(filteredDropdownOptions)}
        destroyPopupOnHide={destroyPopupOnHide}
        placement={dropdownPlacement}
        disabled={disabled}
        variant="outlined"
      >
        {buttonComponent
          ? buttonComponent
          : this.getButtonComponent({
              type,
            })}
      </SplitButtonDropdown>
    );
  };

  getFilteredOptions = ({ options }) => {
    const { searchText } = this.state;
    const { t } = this.props;

    if (!searchText) return options;

    const normalizedSearchText = _.toLower(_.trim(searchText));

    if (!normalizedSearchText) return options;

    const isOptionMatched = option => {
      const normalizedLabel = _.toLower(t(option.label));
      return _.includes(normalizedLabel, normalizedSearchText);
    };

    const filterOptionsRecursively = optionsList => {
      const filteredOptions = [];

      _.forEach(optionsList, option => {
        if (option?.isDivider) return;

        if (isOptionMatched(option)) {
          filteredOptions.push(option);
          return;
        }

        if (option?.isItemGroup || option?.isSubMenu) {
          const filteredChildren = filterOptionsRecursively(
            _.get(option, "options", [])
          );

          if (!_.isEmpty(filteredChildren)) {
            filteredOptions.push({
              ...option,
              options: filteredChildren,
            });
          }
        }
      });

      return filteredOptions;
    };

    return filterOptionsRecursively(options);
  };

  removeEmptyGroupedOptions = ({ options }) => {
    return _.reduce(
      options,
      (acc, option) => {
        if (!option) return acc;

        if (option?.isItemGroup || option?.isSubMenu) {
          const cleanedChildren = this.removeEmptyGroupedOptions({
            options: _.get(option, "options", []),
          });

          if (!_.isEmpty(cleanedChildren)) {
            acc.push({
              ...option,
              options: cleanedChildren,
            });
          }

          return acc;
        }

        acc.push(option);
        return acc;
      },
      []
    );
  };

  render() {
    const {
      showMediaCreation,
      showNoteModal,
      showLinkModal,
      showWorkbookModal,
      showCaptureScreen,
      showDescriptionModal,
      showResourceBank,
      ltiModal,
      ltiService,
      createDriveModal,
      serviceType,
      documentType,
      showNameModal,
      showToddleDocModal,
      codeEditorAttachmentId,
      createdToddleDocAttachment,
    } = this.state;
    const {
      exportAsPdf,
      parentId,
      parentType,
      accept,
      buttonComponent,
      buttonDropDownContainerStyle = {},
      containerStyle = {},
      buttonParentStyle = {},
      t,
      onDropDownOptionClick,
      addMediaText,
      zoomPromptText,
      portalType,
      shouldCreateAsMedia,
      mediaCreationOptions,
      addButtonStyles = {},
      addAttachmentOptions,
      sourceType,
      isShowIconsInBar,
      shouldCallMutation,
      updateAttachments,
      attachments,
      buttonDropdownParentContainerStyle,
      multiselect,
      hoverContainerStyles,
      enableShareModal,
      isNewDropdown,
      getNewDropdownPopupContainer,
      disabled,
      defaultExportType,
      dropdownPlacement,
      attachmentExportOptions,
      onMultipleFilesUploaded,
      createButtonComponentConfig,
      maxSize,
      addAttachment,
      isSplitDropdown,
      destroyPopupOnHide,
      updateLinkModalRef,
      dropDownOptions,
      audioRecordingLimit,
      isDropdownWithoutOverlay,
      showNewDesignForCaptureOptions,
      visible,
      onVisibleChange,
      testId,
      hideGlobalTrayOnCapture = true,
      overrideClasses = {},
      excludeFileExtensionsList,
      curriculumProgramType,
      showDisplayText,
      isGlobalHeaderEnabled,
      enableShortcut,
      assessmentId,
      assignmentId,
      courseId,
      ltiDropDownOptions,
      createLTIScoreTool,
      dsVersion,
      allowMultipleFiles,
      showAudioRecorderV5,
      audioRecorderV5Position,
      modalDimensions,
      validateOnUserInput = false,
    } = this.props;
    let filteredDropdownOptions = _.filter(
      dropDownOptions,
      item => !item.perm || ACLStore.can(item.perm)
    );

    if (
      _.isEqual(sourceType, "LTI_TEMPLATE") &&
      !_.isEmpty(ltiDropDownOptions)
    ) {
      filteredDropdownOptions = ltiDropDownOptions;
    }

    filteredDropdownOptions = this.removeEmptyGroupedOptions({
      options: filteredDropdownOptions,
    });

    filteredDropdownOptions = this.getFilteredOptions({
      options: filteredDropdownOptions,
    });

    const type = _.get(createButtonComponentConfig, "type", "");

    const screenPanelProps = {
      onCloseClick: () => this.toggleCaptureScreen(),
      updatePost: this.updatePost,
      postDetails: { attachments: [] },
    };

    const mapAttachmentOptions = _.map(
      filteredDropdownOptions,
      (dropdownOption, index) => {
        return this.getDropdownItemByKey(dropdownOption, index);
      }
    );

    const flatOptionsArray = (() => {
      const result = [];
      const traverse = list => {
        _.forEach(list, option => {
          if (!option) return;
          if (option.options) traverse(option.options);
          else result.push(option);
        });
      };
      traverse(filteredDropdownOptions);
      return result;
    })();

    const handleShortcuts = pressedKeys => {
      const { code, shiftKey, altKey, ctrlKey, metaKey } = _.first(pressedKeys);
      if (CODE_MAPPING[code] && !(shiftKey || altKey || ctrlKey || metaKey)) {
        const shortcut = CODE_MAPPING[code];
        const option = _.find(
          flatOptionsArray,
          option => option.keyboardShortcut === shortcut
        );
        if (option) {
          this.onClickDropdownOption({ key: option.key });
          return true;
        }
        return false;
      }
      return false;
    };

    const isSubmissionTemplate = _.isEqual(sourceType, "STUDENT_TEMPLATE");
    const isUnitResource = _.includes(
      ["UNIT_PLAN", "ORG_RESOURCES"],
      parentType
    );

    const extraCreateDriveDocumentProps = isSubmissionTemplate
      ? { type: "TEMPLATE_DOCUMENT" }
      : isUnitResource
      ? { type: "RESOURCE_DOCUMENT" }
      : {};

    const workbookMode = _.isEqual(sourceType, "OPENING_MESSAGE_RESOURCE")
      ? WORKBOOK_MODE_TYPES["AI_TUTOR_RESOURCE"]
      : undefined;

    const shouldEnableWorkbookSchoolTemplate =
      shouldEnableWorkbookSchoolTemplateLibrary({
        curriculumProgramType,
      }) && workbookMode !== WORKBOOK_MODE_TYPES["AI_TUTOR_RESOURCE"];

    return (
      <React.Fragment>
        {!shouldCreateAsMedia &&
          !isShowIconsInBar &&
          (isNewDropdown || isSplitDropdown) &&
          this.renderHiddenPickerComponents(filteredDropdownOptions)}
        {showWorkbookModal && (
          <ConditionalWrapper
            condition={shouldEnableWorkbookSchoolTemplate}
            wrapper={
              <WorkbookTemplateWrapperV2
                closeModal={this.closeWorkBook}
                onUpdateSuccessfully={this.onWorkbookSuccessfullyUpdate}
                updateAttachments={updateAttachments}
                addAttachment={addAttachment}
                portalType={portalType}
              />
            }
            type={"wrapperAsElement"}
          >
            <WorkbookTemplateWrapper
              workbookMode={workbookMode}
              closeModal={this.closeWorkBook}
              onUpdateSuccessfully={this.onWorkbookSuccessfullyUpdate}
              updateAttachments={updateAttachments}
              addAttachment={addAttachment}
              portalType={portalType}
            />
          </ConditionalWrapper>
        )}
        {showDescriptionModal && this.getDescriptionModal()}
        {!shouldCreateAsMedia ? (
          isShowIconsInBar ? (
            <div className={classes.iconBarContainer}>
              {mapAttachmentOptions}
            </div>
          ) : isNewDropdown ? (
            isSplitDropdown ? (
              this.getSplitDropdownButton(filteredDropdownOptions)
            ) : isDropdownWithoutOverlay ? (
              this.getDropdownStructure(filteredDropdownOptions)
            ) : (
              <KeyboardShortcuts
                handleShortcuts={handleShortcuts}
                areShortcutsEnabled={enableShortcut}
              >
                <Dropdown
                  overlay={this.getDropdownStructure(filteredDropdownOptions)}
                  destroyPopupOnHide={destroyPopupOnHide}
                  placement={dropdownPlacement}
                  disabled={disabled}
                  getPopupContainer={getNewDropdownPopupContainer}
                  visible={visible}
                  onVisibleChange={onVisibleChange}
                >
                  {buttonComponent
                    ? buttonComponent
                    : this.getButtonComponent({
                        type,
                      })}
                </Dropdown>
              </KeyboardShortcuts>
            )
          ) : isSplitDropdown ? (
            this.getSplitDropdownButton(filteredDropdownOptions)
          ) : (
            <ButtonDropdown
              containerStyle={{
                ...buttonDropDownStyle.containerStyle,
                ...buttonDropDownContainerStyle,
              }}
              buttonComponent={
                buttonComponent
                  ? buttonComponent
                  : this.getButtonComponent({
                      type,
                    })
              }
              buttonParentStyle={{
                ...buttonDropDownStyle.buttonParentStyle,
                ...buttonParentStyle,
              }}
              dropdownComponent={
                <div
                  className={classes.hoverContainer}
                  style={hoverContainerStyles}
                >
                  {mapAttachmentOptions}
                </div>
              }
              parentContainerStyle={buttonDropdownParentContainerStyle}
              buttonComponentStyle={
                this.props.buttonDropdownButtonComponentStyle
              }
              disabled={disabled}
            />
          )
        ) : buttonComponent ? (
          buttonComponent
        ) : (
          <div
            className={classes.container}
            style={containerStyle}
            onClick={() => this.toggleMediaCreation(true)}
            tabIndex={0}
            onKeyDown={e =>
              onEnterOrSpaceKeyDown(e, () => this.toggleMediaCreation(true))
            }
          >
            <div
              className={classes.innerContainer}
              style={_.get(addButtonStyles, "addButtonContainerStyle", {})}
            >
              <AddCircleIcon
                fill={colors.neutral400}
                width={20}
                height={20}
                {..._.get(addButtonStyles, "addIconStyles", {})}
              />
              <div
                className={classes.addMediaText}
                style={addButtonStyles.addTextStyle}
              >
                {addMediaText ? addMediaText : t("common:add_attachments")}
              </div>
            </div>
          </div>
        )}
        {showCaptureScreen.capture_image && (
          <UIModal
            isOpen
            isFullScreen
            overlayContainer={overrideClasses.captureScreenOverlayContainer}
          >
            <CaptureImage
              setToastMsg={setToastMsg}
              screenPanelProps={screenPanelProps}
              showDesignV2={showNewDesignForCaptureOptions}
              hideGlobalTray={hideGlobalTrayOnCapture}
            />
          </UIModal>
        )}
        {showCaptureScreen.capture_video && (
          <UIModal
            isOpen
            isFullScreen
            overlayContainer={overrideClasses.captureScreenOverlayContainer}
          >
            <CaptureVideo
              setToastMsg={setToastMsg}
              screenPanelProps={screenPanelProps}
              showDesignV2={showNewDesignForCaptureOptions}
              hideGlobalTray={hideGlobalTrayOnCapture}
            />
          </UIModal>
        )}
        {showCaptureScreen?.capture_voice ? (
          showAudioRecorderV5 ? (
            <AudioRecorderV5
              showVisualiser
              visualiserColor="#cccccc"
              frameRate={30}
              limit={audioRecordingLimit}
              title={t("common:record_audio")}
              closeModal={this.onAudioRecorderV5ModalClose}
              handleAudioFile={this.handleAudioRecorderV5File}
              onCancel={_.noop}
              restartRecording={this.restartAudioRecorderV5Recording}
              ref={this.audioRecorderV5Ref}
              forPlayerVersion5={true}
              position={audioRecorderV5Position}
              testId={testId}
            />
          ) : (
            <UIModal isOpen={true} isFullScreen={true}>
              <VoiceRecorder
                setToastMsg={setToastMsg}
                screenPanelProps={screenPanelProps}
                testId={testId}
              />
            </UIModal>
          )
        ) : null}
        {showLinkModal ? (
          <LinkModal
            testId={testId}
            customRef={updateLinkModalRef}
            onLinkAdd={this.onLinkAdd}
            onClose={this.toggleLinkModal}
            showDisplayText={showDisplayText}
            isGlobalHeaderOnMultipleScreensEnabled={isGlobalHeaderEnabled}
            dsVersion={dsVersion}
            parentType={parentType}
            validateOnUserInput={validateOnUserInput}
          />
        ) : null}

        {showNoteModal && (
          <AddNoteDialogue
            testId={testId}
            mode={"add"}
            onClose={this.toddleAddNoteDialogue}
            dsVersion={dsVersion}
            isGlobalHeaderOnMultipleScreensEnabled={isGlobalHeaderEnabled}
            saveNote={this.saveNote}
            modalDimensions={modalDimensions}
          />
        )}

        {showToddleDocModal && (
          <ToddleDoc
            mode={_.isEmpty(createdToddleDocAttachment) ? CREATE : EDIT}
            onClose={this.closeToddleDoc}
            createAttachment={this.createToddleDoc}
            createdToddleDocAttachment={createdToddleDocAttachment}
          />
        )}

        {codeEditorAttachmentId && (
          <CodeEditor
            attachmentId={codeEditorAttachmentId}
            onClose={() => this.setState({ codeEditorAttachmentId: null })}
          />
        )}

        {showMediaCreation && (
          <CreatePost
            onClose={() => this.toggleMediaCreation(false)}
            parentType={parentType}
            parentId={parentId}
            mediaCreationOptions={mediaCreationOptions}
            audioRecordingLimit={audioRecordingLimit}
            assignmentId={assignmentId}
            assessmentId={assessmentId}
            allowMultipleFiles={allowMultipleFiles}
          />
        )}

        {showResourceBank && (
          <ResourceBank
            multi={multiselect}
            parentId={parentId}
            id="CREATE_DROPDOWN"
            parentType={parentType}
            closeResource={this.closeResourceBank}
            onContentUploaded={this.onResourceBankContentUpload}
          />
        )}

        {ltiModal ? (
          <LTIClassroomWrapper
            serviceName={ltiService}
            parentType={parentType}
            portalType={portalType}
            toggleLTIComponent={this.toggleLTIComponent}
            courseId={courseId}
            assessmentId={assessmentId}
            onLinkAdd={this.onLinkAdd}
            showSaveButton={true}
            createLTIScoreTool={createLTIScoreTool}
          />
        ) : null}
        {createDriveModal ? (
          <CreateDriveDocument
            t={t}
            closeDriveDocument={this.closeCreateDriveModal}
            updateFilesCount={this.updateFilesCount}
            onSingleContentUploaded={this.onContentUploaded}
            onMultipleFilesUploaded={onMultipleFilesUploaded}
            parentId={parentId}
            parentType={parentType}
            sourceType={sourceType}
            defaultExportType={defaultExportType}
            attachmentExportOptions={attachmentExportOptions}
            serviceType={serviceType}
            documentType={documentType}
            courseId={courseId}
            {...extraCreateDriveDocumentProps}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapActionCreators = {
  setToastMsg,
  uploadAttachments,
  updateAttachment,
};
const addCreateDriveOptions = ({
  isNewDropdown,
  dropDownOptions,
  isShowIconsInBar,
  attachmentExportOptions,
  storageType,
  accept,
  isStudentTemplate,
  insertGoogleAndMicrosoftOptionsKey,
  renderGoogleMicrosoftAsItemGroup,
}) => {
  const isGoogleEnabled =
    ACLStore.can(ENABLE_GOOGLE_DRIVE) &&
    _.includes(storageType, GOOGLE_SERVICE_TYPE);
  const isMicrosoftEnabled =
    ACLStore.can(ENABLE_ONE_DRIVE) &&
    _.includes(storageType, MICROSOFT_SERVICE_TYPE);

  const isToddleDocsInSubmissionTemplateEnabled = ACLStore.can(
    "FeatureFlag:EnableToddleDocsInSubmissionTemplate"
  );

  // Toddle Doc is independent of third-party (Google/Microsoft) storage and
  // of ENABLE_CREATE_DRIVE_DOCUMENTS — it must appear in the submission template
  // field whenever EnableToddleDocsInSubmissionTemplate is on, even when no
  // Google/Microsoft options are present. Insert before the Google/Microsoft
  // gates below so those early returns can't strip it out.
  if (isStudentTemplate && isToddleDocsInSubmissionTemplateEnabled) {
    const toddleDocInsertIndex = _.findIndex(
      dropDownOptions,
      opt => opt.key === "create_template_multipage"
    );
    if (toddleDocInsertIndex !== -1) {
      dropDownOptions.splice(toddleDocInsertIndex + 1, 0, {
        key: "TODDLE_DOC",
        label: "classRoom:create_toddle_doc",
        showDivider: false,
        icon: (
          <PageFoldPortraitOutlined
            size={"x-small"}
            style={styles.iconButtonStyle}
          />
        ),
      });
    }
  }

  const isCreateDriveDocumentEnabled = ACLStore.can(
    ENABLE_CREATE_DRIVE_DOCUMENTS
  );
  const isNewDocAccepted =
    isStudentTemplate ||
    _.isEmpty(accept) ||
    (isGoogleEnabled &&
      _.some(GOOGLE_OPTIONS, option => _.includes(accept, option.mimeType))) ||
    (isMicrosoftEnabled &&
      _.some(MICROSOFT_OPTIONS, option => _.includes(accept, option.mimeType)));

  if (
    _.isEmpty(dropDownOptions) ||
    !isCreateDriveDocumentEnabled ||
    (!isGoogleEnabled && !isMicrosoftEnabled) ||
    (!isNewDropdown && !isShowIconsInBar) ||
    (!_.isEmpty(attachmentExportOptions) &&
      !_.includes(attachmentExportOptions, "LINK")) ||
    !isNewDocAccepted
  ) {
    return;
  }
  //return if none of the target keys are present in the options
  const targetKeys = [GOOGLE_DRIVE, ONE_DRIVE, SHAREPOINT_DRIVE];
  const extractKeys = obj => {
    return [obj.key, ..._.flatMap(obj.options || [], extractKeys)];
  };
  const allKeys = _.flatMap(dropDownOptions, extractKeys);
  if (_.isEmpty(_.intersection(allKeys, targetKeys))) return;
  if (
    insertGoogleAndMicrosoftOptionsKey &&
    _.isEmpty(_.intersection(allKeys, [insertGoogleAndMicrosoftOptionsKey]))
  )
    return;

  const insertGoogleMicrosoft = (
    options,
    insertAt = options.length,
    isGroupedOrSubMenu = true
  ) => {
    const shouldAddGoogleOptions =
      isGoogleEnabled && !_.find(options, { key: "GOOGLE_DOCUMENTS" });
    const shouldAddMicrosoftOptions =
      isMicrosoftEnabled && !_.find(options, { key: "MICROSOFT_DOCUMENTS" });

    if (shouldAddGoogleOptions) {
      options.splice(insertAt++, 0, {
        isSubMenu: !renderGoogleMicrosoftAsItemGroup,
        isItemGroup: renderGoogleMicrosoftAsItemGroup,
        key: "GOOGLE_DOCUMENTS",
        label:
          isGroupedOrSubMenu || renderGoogleMicrosoftAsItemGroup
            ? "common:google"
            : "common:create_from_google",
        options: _.filter(
          GOOGLE_OPTIONS,
          option =>
            isStudentTemplate ||
            _.isEmpty(accept) ||
            _.includes(accept, option.mimeType)
        ),
        showDivider:
          shouldAddMicrosoftOptions && renderGoogleMicrosoftAsItemGroup,
        icon: <GoogleColored />,
      });
    }

    if (shouldAddMicrosoftOptions) {
      options.splice(insertAt, 0, {
        isSubMenu: !renderGoogleMicrosoftAsItemGroup,
        isItemGroup: renderGoogleMicrosoftAsItemGroup,
        key: "MICROSOFT_DOCUMENTS",
        label:
          isGroupedOrSubMenu || renderGoogleMicrosoftAsItemGroup
            ? "common:microsoft"
            : "common:create_from_microsoft",
        options: _.filter(
          MICROSOFT_OPTIONS,
          option =>
            isStudentTemplate ||
            _.isEmpty(accept) ||
            _.includes(accept, option.mimeType)
        ),
        showDivider: false,
        icon: <MicrosoftColored />,
      });
    }
  };

  const insertCreateGroup = atIndex => {
    dropDownOptions.splice(atIndex, 0, {
      isItemGroup: true,
      key: "CREATE",
      label: "common:create",
      options: [],
    });
    insertGoogleMicrosoft(dropDownOptions[atIndex].options);
  };

  const insertCreateSubMenu = atIndex => {
    dropDownOptions.splice(atIndex, 0, {
      isSubMenu: true,
      key: "CREATE",
      label: "common:create",
      icon: <ScopeAndSequenceAddOutlined />,
      options: [],
    });
    insertGoogleMicrosoft(dropDownOptions[atIndex].options);
  };
  const checkCustomKeyAndInsert = options => {
    for (const option of options) {
      if (option.key === insertGoogleAndMicrosoftOptionsKey) {
        const childOptions = _.get(option, "options", []);
        insertGoogleMicrosoft(childOptions);
        return true;
      }

      const childOptions = _.get(option, "options", []);
      if (_.size(childOptions) > 0) {
        const inserted = checkCustomKeyAndInsert(childOptions);
        if (inserted) {
          return true;
        }
      }
    }

    return false;
  };

  if (insertGoogleAndMicrosoftOptionsKey) {
    const inserted = checkCustomKeyAndInsert(dropDownOptions);
    if (inserted) return;
  }

  const groupItem = _.find(dropDownOptions, {
    isItemGroup: true,
    key: "CREATE",
  });

  if (groupItem) {
    insertGoogleMicrosoft(groupItem.options);
    return;
  }

  const subMenuItem = _.find(dropDownOptions, {
    isSubMenu: true,
    key: "CREATE",
  });

  if (subMenuItem) {
    insertGoogleMicrosoft(subMenuItem.options);
    return;
  }

  const lastGroupIndex = _.findLastIndex(dropDownOptions, {
    isItemGroup: true,
  });
  if (lastGroupIndex !== -1) {
    insertCreateGroup(lastGroupIndex + 1);
    return;
  }

  const lastSubMenuIndex = _.findLastIndex(
    dropDownOptions,
    item =>
      item.isSubMenu === true &&
      item.key !== "GOOGLE_DOCUMENTS" &&
      item.key !== "MICROSOFT_DOCUMENTS"
  );

  if (lastSubMenuIndex !== -1) {
    insertCreateSubMenu(lastSubMenuIndex + 1);
    return;
  }

  const insertIndex = _.findLastIndex(dropDownOptions, opt =>
    targetKeys.includes(opt.key)
  );
  if (insertIndex !== -1) {
    insertGoogleMicrosoft(dropDownOptions, insertIndex + 1, false);
  }
};

const mapStateToProps = (state, props) => {
  const {
    useIconWithDropdownOptions,
    parentType,
    audioRecordingLimit,
    assessmentGradeId,
  } = props;
  const userInfo = getUserInfo();
  const userType = _.get(userInfo, "user_type", "");
  const userId = _.get(userInfo, "id", "");
  const orgId = userInfo.org_id;
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    "IB_PYP"
  );
  const curriculumProgramId = getSelectedCurriculumId(state);
  let gradeId = _.get(state, "teacher.selected_class.selected_grades[0]", "");
  if (_.isEmpty(gradeId) && getIsLearningCoursesEnabled()) {
    gradeId = _.get(
      state,
      "learningCourse.selectedLearningCourse.grades[0]",
      ""
    );
  }
  if (_.isEmpty(gradeId) && !_.isEmpty(assessmentGradeId)) {
    gradeId = assessmentGradeId;
  }

  let grade;
  if (gradeId) {
    const gradeDetails = getGradeBasicDetailsFromCache(gradeId);
    grade = _.get(gradeDetails, "globalGrade.uid", null);
  }

  const dropDownOptions = _.get(props, "dropDownOptions");
  const sourceType = _.get(props, "sourceType");
  const courseId = _.get(props, "courseId", "");
  const curriculumId = _.get(props, "curriculumId", "");
  let isIncreasedUploadLimit = _.get(props, "isIncreasedUploadLimit", false);
  if (!isIncreasedUploadLimit) {
    const isSubmissionType = _.includes(
      [
        "STUDENT_ASSIGNMENT_SUBMISSION",
        "PROJECT_REPORT_SUBMISSION_FINAL",
        "PROJECT_GROUP_SUBMISSION_ITEM_TEMPLATE",
        "QUESTION_SUBMISSION_ATTACHMENT",
      ],
      parentType
    );

    isIncreasedUploadLimit =
      isIncreasedUploadLimitEnabled(curriculumProgramId) && isSubmissionType;
  }

  //adding microsoft option for student template if key is not already present
  if (
    sourceType === "STUDENT_TEMPLATE" &&
    _.isEmpty(
      _.find(
        dropDownOptions,
        option => _.get(option, "key") == MICROSOFT_DRIVE_OPTION.key
      )
    )
  ) {
    dropDownOptions.push(MICROSOFT_DRIVE_OPTION);
  }

  if (useIconWithDropdownOptions) {
    _.forEach(dropDownOptions, option => {
      const icon = _.get(
        _.find(DROP_DOWN_OPTIONS_WITH_ICONS, { key: option.key }),
        "icon",
        null
      );
      if (icon) {
        option.icon = icon;
      }
    });
  }

  //adding sharepoint option sourceType other than student template
  if (enableSharepointPickerForUser({ userType, sourceType })) {
    const isSharepointOptionPresent = options => {
      return _.some(
        options,
        option => _.get(option, "key") === SHAREPOINT_DRIVE
      );
    };

    const updateOptions = (options, isGrouped) => {
      const shouldReplace = enableSharepointPickerV2ForUser(userType);
      const index = _.findIndex(options, { key: ONE_DRIVE });

      if (index !== -1) {
        if (shouldReplace) {
          _.assign(options[index], {
            key: SHAREPOINT_DRIVE,
            label: isGrouped
              ? "onedrive_sharepoint"
              : "add_onedrive_sharepoint",
            icon: options[index].icon,
            keyboardShortcut: options[index].keyboardShortcut,
          });
        } else {
          options.splice(index + 1, 0, {
            ...SHAREPOINT_DRIVE_OPTION,
            label: isGrouped ? "sharepoint" : "add_sharepoint_drive",
            icon: options[index].icon ? SHAREPOINT_DRIVE_OPTION.icon : null,
          });
        }
      }
    };

    const getUploadMenu = options =>
      _.find(
        options,
        item =>
          (item.isItemGroup || item.isSubMenu) &&
          _.includes(["UPLOAD", "UPLOAD_MENU"], _.toUpper(item.key))
      );

    let uploadItem = getUploadMenu(dropDownOptions);

    const flatOptions = _.flatMap(dropDownOptions, opt =>
      _.get(opt, "options", [])
    );

    if (!uploadItem) {
      uploadItem = getUploadMenu(flatOptions);
    }

    if (uploadItem && !isSharepointOptionPresent(uploadItem?.options)) {
      updateOptions(uploadItem?.options, true);
    } else if (!isSharepointOptionPresent(dropDownOptions)) {
      updateOptions(dropDownOptions, false);
    }
  }

  return {
    curriculumProgramType,
    grade,
    dropDownOptions,
    orgId,
    sourceType,
    courseId,
    curriculumId,
    userType,
    isIncreasedUploadLimit,
    audioRecordingLimit: isIncreasedUploadLimit
      ? SUBMISSION_MAX_AUDIO_RECORD_LIMIT
      : audioRecordingLimit,
    userId,
    curriculumProgramId,
  };
};

CreateDropDown.propTypes = {
  cardType: PropTypes.string,
  exportAsPdf: PropTypes.bool,
  buttonDropDownContainerStyle: PropTypes.object,
  accept: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  parentId: PropTypes.string,
  parentType: PropTypes.string,
  containerStyle: PropTypes.object,
  dropDownOptions: PropTypes.array,
  multiselect: PropTypes.bool,
  isNewDropdown: PropTypes.bool,
  isDropdownWithoutOverlay: PropTypes.bool,
  getNewDropdownPopupContainer: PropTypes.func,
  customizedFile: PropTypes.func,
  onUploadFromDevice: PropTypes.func,
  disabled: PropTypes.bool,
  dropzoneClass: PropTypes.string,
  attachmentExportOptions: PropTypes.array,
  showV2Icons: PropTypes.bool,
  customDropZoneStyle: PropTypes.object,
  buttonComponentConfig: PropTypes.object,
  showDescription: PropTypes.bool,
  destroyPopupOnHide: PropTypes.bool,
  updateLinkModalRef: PropTypes.func,
  audioRecordingLimit: PropTypes.number,
  showCaptureVoiceIcon: PropTypes.bool,
  iconButtonVariant: PropTypes.string,
  iconButtonType: PropTypes.string,
  iconButtonVariantV2: PropTypes.string,
  reduceSpacingBetweenIcons: PropTypes.bool,
  compactSpacingBetweenIcons: PropTypes.bool,
  showPlaceholderFileIcon: PropTypes.bool,
  isAudioDisabled: PropTypes.bool,
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  excludeFileExtensionsList: PropTypes.array,
  dsVersion: PropTypes.string,
  customFilterFilesHandler: PropTypes.func,
  showDisplayText: PropTypes.bool,
  testId: PropTypes.string,
  courseId: PropTypes.string,
  assessmentId: PropTypes.string,
  createLTIScoreTool: PropTypes.bool,
  curriculumId: PropTypes.string,
  dropdownMenuSize: PropTypes.string,
  appendIndexWithKey: PropTypes.bool,
  allowMultipleFiles: PropTypes.bool,
  showAudioRecorderV5: PropTypes.bool,
  audioRecorderV5Position: PropTypes.object,
  onAfterDropdownOptionClick: PropTypes.func,
  isSearchEnabled: PropTypes.bool,
  insertGoogleAndMicrosoftOptionsKey: PropTypes.string,
  renderGoogleMicrosoftAsItemGroup: PropTypes.bool,
  overlayHeight: PropTypes.string,
  hasMultilineOptions: PropTypes.bool,
};

CreateDropDown.defaultProps = {
  exportAsPdf: false,
  parentId: "",
  parentType: "",
  buttonDropDownContainerStyle: {},
  buttonDropDownStyle: {},
  cardType: "horizontal",
  containerStyle: {},
  shouldCreateAsMedia: false,
  dropDownOptions: DROP_DOWN_OPTIONS,
  isShowIconsInBar: false,
  multiselect: true,
  hoverContainerStyles: {},
  isNewDropdown: false,
  enableShortcut: false,
  isDropdownWithoutOverlay: false,
  getNewDropdownPopupContainer: null,
  disabled: false,
  attachmentExportOptions: ["LINK", "FILE"],
  showV2Icons: false,
  customDropZoneStyle: {},
  buttonComponentConfig: {},
  showDescription: false,
  destroyPopupOnHide: false,
  showCaptureVoiceIcon: false,
  iconButtonVariant: "outlined-subtle",
  reduceSpacingBetweenIcons: false,
  compactSpacingBetweenIcons: false,
  showPlaceholderFileIcon: false,
  isAudioDisabled: false,
  onVisibleChange: null,
  excludeFileExtensionsList: [],
  showDisplayText: true,
  testId: "appComponents-attachmentDropDown",
  dropdownMenuSize: "medium",
  iconButtonSize: "medium",
  allowMultipleFiles: false,
  useIconWithDropdownOptions: false,
  showAudioRecorderV5: false,
  audioRecorderV5Position: {},
  isSearchEnabled: false,
  insertGoogleAndMicrosoftOptionsKey: "",
  renderGoogleMicrosoftAsItemGroup: false,
  overlayHeight: "",
  hasMultilineOptions: false,
};

export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, mapActionCreators, null, { withRef: true }),
  graphql(getOrganizationGlobalConstantsQuery, {
    name: "getOrganizationGlobalConstants",

    options: ({ orgId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        organizationId: orgId,
        filter: {
          names: ["THIRD_PARTY_SERVICE_TYPE_PREFERENCE"],
        },
      },
    }),
    skip: ({ sourceType }) => {
      return (
        !_.includes(
          ["STUDENT_TEMPLATE", "PROJECT_GROUP_REPORT_TEMPLATE"],
          sourceType
        ) && !ACLStore.can(ENABLE_CREATE_DRIVE_DOCUMENTS)
      );
    },
    props({
      getOrganizationGlobalConstants,
      ownProps: {
        isData,
        isLoading,
        dropDownOptions,
        sourceType,
        ltiDropDownOptions,
        ltiToolAttachmentAdded,
        isNewDropdown,
        isShowIconsInBar,
        attachmentExportOptions,
        accept,
        insertGoogleAndMicrosoftOptionsKey,
        renderGoogleMicrosoftAsItemGroup,
      },
    }) {
      const data = getOrganizationGlobalConstantsFromCache(
        getOrganizationGlobalConstants.variables
      );
      const organizationConstants = _.get(data, "node.globalConstants", []);
      const storageTypeString = _.get(
        _.find(organizationConstants, {
          name: "THIRD_PARTY_SERVICE_TYPE_PREFERENCE",
        }),
        "value",
        JSON.stringify([GOOGLE_SERVICE_TYPE])
      );
      const storageType = JSON.parse(storageTypeString);
      let updatedDropDownOptions = _.clone(dropDownOptions);

      if (
        storageType &&
        _.includes(
          ["STUDENT_TEMPLATE", "PROJECT_GROUP_REPORT_TEMPLATE"],
          sourceType
        )
      ) {
        if (!_.includes(storageType, MICROSOFT_SERVICE_TYPE)) {
          updatedDropDownOptions = dropDownOptions.filter(
            ({ key }) =>
              !_.includes(
                [ONE_DRIVE, SHAREPOINT_DRIVE, "MICROSOFT_DOCUMENTS"],
                key
              )
          );
        }
        if (!_.includes(storageType, GOOGLE_SERVICE_TYPE)) {
          updatedDropDownOptions = dropDownOptions.filter(
            ({ key }) => !_.includes([GOOGLE_DRIVE, "GOOGLE_DOCUMENTS"], key)
          );
        }
        if (_.includes(storageType, STUDENT_TEMPLATE_OPTION_NONE)) {
          updatedDropDownOptions = dropDownOptions.filter(
            ({ key }) =>
              !_.includes(
                [
                  GOOGLE_DRIVE,
                  ONE_DRIVE,
                  SHAREPOINT_DRIVE,
                  "GOOGLE_DOCUMENTS",
                  "MICROSOFT_DOCUMENTS",
                ],
                key
              )
          );
        }
      }

      if (
        _.isEqual(sourceType, "STUDENT_TEMPLATE") &&
        !_.isEmpty(ltiDropDownOptions)
      ) {
        const LTI_OPTIONS = {
          isSubMenu: true,
          key: "LTI_OPTIONS",
          label: "classRoom:add_external_tool",
          options: ltiDropDownOptions,
          disabled: ltiToolAttachmentAdded,
          disabledTooltip: "classRoom:only_add_one_external_tool_template",
          icon: <MoveToAssignedCircleOutlined />,
        };
        updatedDropDownOptions.push(LTI_OPTIONS);
      }
      // adding create document options for google and microsoft based on flag here in dropdown options
      // eventually need to pass this when we are creating dropdown options with appropirate permission
      addCreateDriveOptions({
        isNewDropdown,
        isShowIconsInBar,
        dropDownOptions: updatedDropDownOptions,
        attachmentExportOptions,
        storageType: _.isEmpty(data)
          ? [STUDENT_TEMPLATE_OPTION_NONE]
          : storageType,
        accept,
        isStudentTemplate: _.isEqual(sourceType, "STUDENT_TEMPLATE"),
        insertGoogleAndMicrosoftOptionsKey,
        renderGoogleMicrosoftAsItemGroup,
      });

      return {
        isData: !_.isEmpty(data) && isData,
        isLoading:
          getOrganizationGlobalConstants["networkStatus"] == 1 ||
          getOrganizationGlobalConstants["networkStatus"] == 2 ||
          isLoading,
        dropDownOptions: updatedDropDownOptions,
      };
    },
  }),
  graphql(getLTIIntegrationsCredsQuery, {
    name: "getLTIIntegrationsCredsV2Query",
    skip: ({ curriculumProgramId, ltiDropDownOptions }) =>
      !curriculumProgramId || _.isEmpty(ltiDropDownOptions),
    options: ({ curriculumProgramId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        input: {
          entityId: [curriculumProgramId],
          entityType: ["CURRICULUM_PROGRAM"],
          context: "ASSIGNMENT",
        },
      },
    }),
    props: ({ getLTIIntegrationsCredsV2Query }) => ({
      ltiIntegrationCreds: _.get(
        getLTIIntegrationsCredsV2Query,
        "integration.getLTIIntegrationsCredsV2.integrationCreds",
        []
      ),
    }),
  })
)(CreateDropDown);
